import {
  ArrayList_init_$Create$2rimpp4x9tjd3 as ArrayList_init_$Create$,
  toList383f556t1dixk as toList,
  Unit_instanceat14thlj150z as Unit_instance,
  addAll1k27qatfgp3k5 as addAll,
  copyToArray2j022khrow2yi as copyToArray,
  toString1pkumu07cwy4m as toString,
  IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$,
  Error3ofk6owajcepa as Error_0,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  listOf1jh22dvmctj1r as listOf,
  plus20p0vtfmu0596 as plus,
  toMutableList3ewlpx8m5ca2q as toMutableList,
  emptyMapr06gerzljqtm as emptyMap,
  Paire9pteg33gng7 as Pair,
  LinkedHashMap_init_$Create$2gfxg59gogbfz as LinkedHashMap_init_$Create$,
  emptyList1g2z5xcrvp2zy as emptyList,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0,
  toDouble1kn912gjoizjp as toDouble,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toString14fd7g605f91p as toString_0,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  contains2el4s70rdq4ld as contains,
  toMutableList20rdgwi7d3cwi as toMutableList_0,
  listOfvhqybd2zx248 as listOf_0,
  Regex_init_$Create$y1ec0tsv67vh as Regex_init_$Create$,
  mapsbvh18eqox7a as map,
  addAll3rgorw6ix9mgp as addAll_0,
  distinct10qe1scfdvu5k as distinct,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  replace3le3ie7l9k8aq as replace,
  firstOrNull1gk7vzkf4h3nq as firstOrNull,
  defineProp3hxgpk2knu2px as defineProp,
  joinToString1cxrrlmo0chqs as joinToString,
  toString30pk9tzaqopn as toString_1,
  LinkedHashSet_init_$Create$161uomhguzhxi as LinkedHashSet_init_$Create$,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  removeAll3o43e67jmwdpc as removeAll,
  reversedArray1jvawboiqjp41 as reversedArray,
  Exception_init_$Create$1f9k5rt5gytdg as Exception_init_$Create$,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  getKClass1s3j9wy1cofik as getKClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  isArray1hxjqtqy632bc as isArray,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  Exceptiondt2hlxn7j7vw as Exception,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  plus27p1csfyhycs6 as plus_0,
  plus2m1vv33moko5t as plus_1,
  sort1opyk0uibi7i3 as sort,
  HashSet_init_$Create$2bsk5herqkxxm as HashSet_init_$Create$,
  joinToStringxqcavsxcmh4q as joinToString_0,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$snys8oz8txtu as LinkedHashMap_init_$Create$_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  contains2gm06f5aa19ov as contains_0,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
} from './kotlin-kotlin-stdlib.mjs';
import {
  merge14fhz8zclcclx as merge,
  SelectableComponent2e9l9zv14vcv9 as SelectableComponent,
  OutlineableComponent1wms50wedlllg as OutlineableComponent,
  DraggableComponent2vg3of9uj9uwn as DraggableComponent,
  ProppingComponent3ntna4jqkya3u as ProppingComponent,
  AlwaysHangDownComponent_instance2s6f7ev3q7y3y as AlwaysHangDownComponent_instance,
  UnserializableEntityComponent3dbbopzug8j88 as UnserializableEntityComponent,
  ProductComponent1yv8c90lajg3y as ProductComponent,
  ProductSpecificationsunk1qtx1k13 as ProductSpecification,
  AssemblyStructureComponent3qqm1io5f7l8g as AssemblyStructureComponent,
  AssemblyPartsComponent_init_$Create$30ms2ttoutmay as AssemblyPartsComponent_init_$Create$,
  AssemblyPartSnapInfo3vtetiub067zv as AssemblyPartSnapInfo,
  Companion_getInstancebkytj44sbgxv as Companion_getInstance,
  AssemblyPart110oq599i90v0 as AssemblyPart,
  Vector1cgy08ha6e7ya as Vector,
  Companion_getInstanceblwi6p98rjjg as Companion_getInstance_0,
  Degrees1pmrlnndueajq as Degrees,
  Transform2e9p9l2euepqa as Transform,
  Companion_getInstance1k2wrnuhjrbuv as Companion_getInstance_1,
  CatalogSizeComponent18xv9v502n7ro as CatalogSizeComponent,
  ColliderShapeComponent102whak4g71e2 as ColliderShapeComponent,
  Sizervsnigdp89bq as Size,
  ConnectorTagConstants_instance25r6fly62d92a as ConnectorTagConstants_instance,
  ConnectorsComponent32a4eg1gtppvf as ConnectorsComponent,
  DragSurface3d7ocyb1ribou as DragSurface,
  DragSurfacesComponent2obth6ol1y4en as DragSurfacesComponent,
  ModelInfoComponentvt7uz6p6kni4 as ModelInfoComponent,
  ModelTransformComponentljn0f1n2gsc8 as ModelTransformComponent,
  ProductStructureConnection2fj7164v4tcgh as ProductStructureConnection,
  ProductStructureItem3ehsotxzwomz5 as ProductStructureItem,
  ProductStructureComponent1n49mlfstxaxv as ProductStructureComponent,
  RelativeConnectorsComponent2s0o9ntl664k2 as RelativeConnectorsComponent,
  ConnectionRootComponent3fd9sp0aqznxo as ConnectionRootComponent,
  DisplayNameComponent37eao6dtqdntj as DisplayNameComponent,
  ProductParamsqcv385pfoovn as ProductParams,
  ProductParamsComponent3tz0lreyu4pf2 as ProductParamsComponent,
  Companion_getInstanceiuj3shxmfy4i as Companion_getInstance_2,
  LoggerState_getInstance458njkt1c1yk as LoggerState_getInstance,
  productSpecification1di33unl59xxe as productSpecification,
  createCustomAssembly2xru0w2yvxl0g as createCustomAssembly,
  createCustomAssemblySpecificationrtotobw2qkrj as createCustomAssemblySpecification,
  ProductCatalog103osycina0dv as ProductCatalog,
  Companion_getInstanceoonrb8185bmg as Companion_getInstance_3,
  Margin55v3iexvqdfb as Margin,
  $serializer_getInstance2thyfr0ndtc2i as $serializer_getInstance,
  $serializer_getInstance2cm4qg7o1asp1 as $serializer_getInstance_0,
} from './core-core-api.mjs';
import {
  DynamicRangeDimensionoovn6z4huzg7 as DynamicRangeDimension,
  MetaDataComponent2cq0ehrtq7cdx as MetaDataComponent,
  VisualLightSourceComponenttdrhcxqvgh5x as VisualLightSourceComponent,
  PositionTemplateSerializer_getInstance48bp9f1t4oxb as PositionTemplateSerializer_getInstance,
  Companion_getInstance3vd3cz8a8h4cg as Companion_getInstance_4,
  MarginTemplateSerializer_getInstance3w2f3vs68h6ag as MarginTemplateSerializer_getInstance,
  Companion_getInstance6xapf1uwypti as Companion_getInstance_5,
  ConnectorItemTemplate158e0vjd7zvbi as ConnectorItemTemplate,
  Companion_getInstanceyff9kgd07fth as Companion_getInstance_6,
  ProductStructureItemTemplatexsgwmn957tuc as ProductStructureItemTemplate,
  $serializer_getInstance1xx8verojzg8g as $serializer_getInstance_1,
  CustomSerializer_getInstance2hqkmf0q3ubar as CustomSerializer_getInstance,
  CustomSerializer_getInstance1qvw3q6uslqof as CustomSerializer_getInstance_0,
  $serializer_getInstanceld03a1a152sw as $serializer_getInstance_2,
  $serializer_getInstancefcepiwcts4gk as $serializer_getInstance_3,
  CustomSerializer_getInstancepfr9byx5mclv as CustomSerializer_getInstance_1,
  Part2q3l7avl1ln6e as Part,
  $serializer_getInstancehu68pl1ql7el as $serializer_getInstance_4,
} from './core-core-range-dynamic-range.mjs';
import {
  DoorComponent1aqj2bxcz9fq3 as DoorComponent,
  DoorFrontComponent_getInstance2e2t42qmfke7o as DoorFrontComponent_getInstance,
  HandleComponent_getInstance3ura479bgq6yv as HandleComponent_getInstance,
  DrawerComponent_getInstancev1maoc1j7lic as DrawerComponent_getInstance,
  FrameComponent_getInstance2c998mz05aq2i as FrameComponent_getInstance,
  LegComponent_getInstance2b9gn5nn97ee3 as LegComponent_getInstance,
  OutlinedComponent3mbv5ff4jycz6 as OutlinedComponent,
  AllowedDoorPairsComponent3mt210f8oa8rk as AllowedDoorPairsComponent,
  AutoAdaptGuestComponentm7ystystq256 as AutoAdaptGuestComponent,
  AutoAdaptHostComponent34qpeh2sq4yhu as AutoAdaptHostComponent,
  CommunicationSizeComponent3b9iyn3tznkse as CommunicationSizeComponent,
  DragProjectionPointComponent373iy7kyauua1 as DragProjectionPointComponent,
  FunctionalMarginShapeComponent1ipzxulknf0p as FunctionalMarginShapeComponent,
  FunctionalZone2cyfwjzx0uu9k as FunctionalZone,
  FunctionalZonesLocalComponent1aj0wo49dpyv3 as FunctionalZonesLocalComponent,
  LightComponentkx6mitxrp2z0 as LightComponent,
  PlacementZoneByHeightComponent17hvd16v0ynlm as PlacementZoneByHeightComponent,
  RecommendedInitialPositionFromFloorComponent2w8snp7w7asn as RecommendedInitialPositionFromFloorComponent,
} from './core-core-stl.mjs';
import {
  Jsonsmkyu9xjl7fv as Json,
  Companion_instanceo6n8nih21ztr as Companion_instance,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonElementSerializer_getInstance2oljfos0dzhs0 as JsonElementSerializer_getInstance,
  get_jsonObject2u4z2ch1uuca9 as get_jsonObject,
  get_jsonArray18sglwhl4pclz as get_jsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import {
  DoubleSerializer_getInstance2y096mioqlqlr as DoubleSerializer_getInstance,
  ReferenceArraySerializer3juj1vqolxkrs as ReferenceArraySerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  StringSerializer_getInstance100dxy5jlaaom as StringSerializer_getInstance,
  BooleanSerializer_getInstance1a8uvzxl1s4k4 as BooleanSerializer_getInstance,
  UnknownFieldException_init_$Create$3p6j2tgfvvykj as UnknownFieldException_init_$Create$,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  KSerializerzf77vz1967fq as KSerializer,
  IntSerializer_getInstance3jjhuzya8j8kz as IntSerializer_getInstance,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  PolymorphicSerializer_init_$Create$1iticqgwls3rt as PolymorphicSerializer_init_$Create$,
  throwArrayMissingFieldExceptionbk1mj238w44a as throwArrayMissingFieldException,
  get_elementNamesl5b6t976dltd as get_elementNames,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(ComponentsCommonData, 'ComponentsCommonData');
initMetadataForInterface(CustomComponentBuilder, 'CustomComponentBuilder');
initMetadataForClass(StaticComponentBuilder, 'StaticComponentBuilder', VOID, VOID, [CustomComponentBuilder]);
initMetadataForInterface(CustomComponentParser, 'CustomComponentParser');
initMetadataForClass(ProductSpecificationBuilder, 'ProductSpecificationBuilder');
initMetadataForClass(AllowedDoorPairsComponentBuilder, 'AllowedDoorPairsComponentBuilder', AllowedDoorPairsComponentBuilder);
initMetadataForClass(AssemblyComponentsBuilder, 'AssemblyComponentsBuilder');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(AutoAdaptGuestComponentBuilder, 'AutoAdaptGuestComponentBuilder');
initMetadataForClass(AutoAdaptHostComponentBuilder, 'AutoAdaptHostComponentBuilder', AutoAdaptHostComponentBuilder);
initMetadataForClass(BooleanComponentBuilder, 'BooleanComponentBuilder');
initMetadataForClass(CatalogSizeComponentBuilder, 'CatalogSizeComponentBuilder', CatalogSizeComponentBuilder);
initMetadataForClass(ColliderShapeComponentBuilder, 'ColliderShapeComponentBuilder', ColliderShapeComponentBuilder);
initMetadataForClass(CommunicationSizeComponentBuilder, 'CommunicationSizeComponentBuilder', CommunicationSizeComponentBuilder);
initMetadataForClass(ConnectorsComponentBuilder, 'ConnectorsComponentBuilder', ConnectorsComponentBuilder);
initMetadataForClass(DragProjectionPointComponentBuilder, 'DragProjectionPointComponentBuilder', DragProjectionPointComponentBuilder);
initMetadataForClass(DragSurfacesComponentBuilder, 'DragSurfacesComponentBuilder', DragSurfacesComponentBuilder);
initMetadataForClass(FunctionalMarginShapeComponentBuilder, 'FunctionalMarginShapeComponentBuilder', FunctionalMarginShapeComponentBuilder);
initMetadataForClass(FunctionalZonesLocalComponentBuilder, 'FunctionalZonesLocalComponentBuilder', FunctionalZonesLocalComponentBuilder);
initMetadataForClass(LightComponentBuilder, 'LightComponentBuilder', LightComponentBuilder);
initMetadataForClass(MetaDataComponentBuilder, 'MetaDataComponentBuilder', MetaDataComponentBuilder);
initMetadataForClass(ModelInfoComponentBuilder, 'ModelInfoComponentBuilder', ModelInfoComponentBuilder);
initMetadataForClass(ModelTransformComponentBuilder, 'ModelTransformComponentBuilder', ModelTransformComponentBuilder);
initMetadataForClass(PlacementZoneByHeightComponentBuilder, 'PlacementZoneByHeightComponentBuilder', PlacementZoneByHeightComponentBuilder);
initMetadataForClass(PolyhedronColliderIdsPair, 'PolyhedronColliderIdsPair');
initMetadataForClass(ProductStructureComponentBuilder, 'ProductStructureComponentBuilder', ProductStructureComponentBuilder);
initMetadataForClass(ProppingComponentBuilder, 'ProppingComponentBuilder', ProppingComponentBuilder);
initMetadataForClass(RecommendedInitialPositionFromFloorComponentBuilder, 'RecommendedInitialPositionFromFloorComponentBuilder', RecommendedInitialPositionFromFloorComponentBuilder);
initMetadataForClass(RelativeConnectorsComponentBuilder, 'RelativeConnectorsComponentBuilder', RelativeConnectorsComponentBuilder);
initMetadataForClass(RequiredComponentsBuilder, 'RequiredComponentsBuilder', RequiredComponentsBuilder);
initMetadataForClass(VisualLightSourceComponentBuilder, 'VisualLightSourceComponentBuilder', VisualLightSourceComponentBuilder);
initMetadataForCompanion(Companion);
initMetadataForClass(IPEXRangeFormatCatalog, 'IPEXRangeFormatCatalog', IPEXRangeFormatCatalog, VOID, [ProductCatalog]);
initMetadataForClass(AmendableCatalog, 'AmendableCatalog', AmendableCatalog, IPEXRangeFormatCatalog);
initMetadataForCompanion(Companion_0);
initMetadataForClass(InheritanceResolver, 'InheritanceResolver');
initMetadataForInterface(ReadOnlyItemRepository, 'ReadOnlyItemRepository');
initMetadataForClass(ItemRepository, 'ItemRepository', ItemRepository, VOID, [ReadOnlyItemRepository]);
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(AssemblyChildDTO, 'AssemblyChildDTO', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ColliderDTO, 'ColliderDTO', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
initMetadataForObject(CustomSerializer, 'CustomSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(ProductDTO, 'ProductDTO', VOID, VOID, VOID, VOID, VOID, {0: CustomSerializer_getInstance_2});
initMetadataForCompanion(Companion_3);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ItemComponentsDTO, 'ItemComponentsDTO', ItemComponentsDTO, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
initMetadataForCompanion(Companion_4);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ItemParametersDTO, 'ItemParametersDTO', ItemParametersDTO, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
initMetadataForClass(ParameterLabel, 'ParameterLabel');
initMetadataForCompanion(Companion_5);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(RangeItemDTO, 'RangeItemDTO', RangeItemDTO, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
initMetadataForCompanion(Companion_6);
initMetadataForClass(ItemParser, 'ItemParser', ItemParser);
//endregion
function buildColliders($this, data, item) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.buildColliders.<anonymous>' call
    var tmp_0;
    try {
      // Inline function 'kotlin.collections.mutableListOf' call
      var ids = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = data.length;
      while (inductionVariable < last) {
        var element = data[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.buildColliders.<anonymous>.<anonymous>' call
        var c = toList(element.getPolyhedronsForSize(tmp1_safe_receiver));
        if (c.o() > 1) {
          var inductionVariable_0 = 1;
          var last_0 = c.o();
          if (inductionVariable_0 <= last_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              ids.h(element.id + ':' + i);
            }
             while (!(i === last_0));
        } else {
          ids.h(element.id);
        }
        var list = c;
        addAll(destination, list);
      }
      var polyhedra = copyToArray(destination);
      var tmp_1 = $this;
      var tmp_2;
      // Inline function 'kotlin.collections.isEmpty' call
      if (polyhedra.length === 0) {
        tmp_2 = null;
      } else {
        if (polyhedra.length === 1) {
          var tmp_3 = polyhedra[0];
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$6 = copyToArray(ids);
          tmp_2 = new PolyhedronColliderIdsPair(tmp_3, tmp$ret$6);
        } else {
          var tmp_4 = merge(polyhedra);
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$7 = copyToArray(ids);
          tmp_2 = new PolyhedronColliderIdsPair(tmp_4, tmp$ret$7);
        }
      }
      tmp_1.l5q_1 = tmp_2;
      tmp_0 = $this.l5q_1;
    } catch ($p) {
      var tmp_5;
      if ($p instanceof Error_0) {
        var e = $p;
        var message = 'Specification of collider not valid. ' + e.message;
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_6;
  if (tmp2_elvis_lhs == null) {
    var message_0 = 'No size set on ' + item.id;
    throw IllegalStateException_init_$Create$(toString(message_0));
  } else {
    tmp_6 = tmp2_elvis_lhs;
  }
  return tmp_6;
}
function ComponentsCommonData(item, modelRootURL) {
  modelRootURL = modelRootURL === VOID ? null : modelRootURL;
  this.item = item;
  this.modelRootURL = modelRootURL;
  this.l5q_1 = null;
}
protoOf(ComponentsCommonData).m5q = function () {
  return this.item;
};
protoOf(ComponentsCommonData).i5o = function () {
  return this.modelRootURL;
};
protoOf(ComponentsCommonData).getColliders = function (colliders) {
  var tmp;
  if (colliders == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.getColliders.<anonymous>' call
    var tmp0_elvis_lhs = this.l5q_1;
    tmp = tmp0_elvis_lhs == null ? buildColliders(this, colliders, this.item) : tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(ComponentsCommonData).getPolyhedronForSize = function (dimension, size) {
  var tmp;
  if (dimension == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.ComponentsCommonData.getPolyhedronForSize.<anonymous>' call
    tmp = dimension.getPolyhedronForSize(size);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_width = size.b2y_1;
    var tmp3_height = size.c2y_1;
    var tmp4_depth = size.d2y_1;
    tmp_0 = (new DynamicRangeDimension(VOID, VOID, tmp4_depth, VOID, tmp3_height, VOID, VOID, VOID, tmp2_width)).getPolyhedronForSize(size);
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
};
function CustomComponentBuilder() {
}
function StaticComponentBuilder(component) {
  this.component = component;
}
protoOf(StaticComponentBuilder).a2q = function () {
  return this.component;
};
protoOf(StaticComponentBuilder).build = function (rangeItem, components, commonData) {
  return this.component;
};
protoOf(StaticComponentBuilder).inherit = function (parentCustomComponentBuilder) {
  return this;
};
function CustomComponentParser() {
}
function buildComponents($this, rangeItem) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var allComponents = ArrayList_init_$Create$();
  var commonData = new ComponentsCommonData(rangeItem, $this.n5q_1);
  if (!(rangeItem.components == null)) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = rangeItem.components.customComponents.h2().k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
      allComponents.h(element.build(rangeItem, rangeItem.components, commonData));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = $this.o5q_1.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
      allComponents.h(element_0.q5q(rangeItem, rangeItem.components, commonData));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = $this.p5q_1.k();
    while (tmp0_iterator_1.m()) {
      var element_1 = tmp0_iterator_1.n();
      // Inline function 'com.ikea.range.ipex.range.builder.ProductSpecificationBuilder.buildComponents.<anonymous>' call
      allComponents.p(element_1.r5q(rangeItem, rangeItem.components, commonData));
    }
  }
  return filterNotNull(allComponents);
}
function ProductSpecificationBuilder$singleBuilders$lambda() {
  return new SelectableComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_0(it) {
  return it.selectable === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_1() {
  return new OutlineableComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_2(it) {
  return it.outlineable === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_3() {
  return new DraggableComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_4(it) {
  return it.draggable === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_5() {
  return new DoorComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_6(it) {
  return it.door === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_7() {
  return DoorFrontComponent_getInstance();
}
function ProductSpecificationBuilder$singleBuilders$lambda_8(it) {
  return it.doorFront === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_9() {
  return HandleComponent_getInstance();
}
function ProductSpecificationBuilder$singleBuilders$lambda_10(it) {
  return it.handle === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_11() {
  return DrawerComponent_getInstance();
}
function ProductSpecificationBuilder$singleBuilders$lambda_12(it) {
  return it.drawer === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_13() {
  return FrameComponent_getInstance();
}
function ProductSpecificationBuilder$singleBuilders$lambda_14(it) {
  return it.frame === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_15() {
  return LegComponent_getInstance();
}
function ProductSpecificationBuilder$singleBuilders$lambda_16(it) {
  return it.leg === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_17() {
  return new OutlinedComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_18(it) {
  return it.outlined === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_19() {
  return new ProppingComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_20(it) {
  return it.propping === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_21() {
  return AlwaysHangDownComponent_instance;
}
function ProductSpecificationBuilder$singleBuilders$lambda_22(it) {
  return it.alwaysHangDown === true;
}
function ProductSpecificationBuilder$singleBuilders$lambda_23() {
  return new UnserializableEntityComponent();
}
function ProductSpecificationBuilder$singleBuilders$lambda_24(it) {
  return it.serializeEntity === false;
}
function ProductSpecificationBuilder(itemRepository, modelRootURL) {
  modelRootURL = modelRootURL === VOID ? null : modelRootURL;
  this.n5q_1 = modelRootURL;
  var tmp = this;
  var tmp_0 = new AutoAdaptGuestComponentBuilder(itemRepository);
  var tmp_1 = ProductSpecificationBuilder$singleBuilders$lambda;
  var tmp_2 = new BooleanComponentBuilder(tmp_1, ProductSpecificationBuilder$singleBuilders$lambda_0);
  var tmp_3 = ProductSpecificationBuilder$singleBuilders$lambda_1;
  var tmp_4 = new BooleanComponentBuilder(tmp_3, ProductSpecificationBuilder$singleBuilders$lambda_2);
  var tmp_5 = ProductSpecificationBuilder$singleBuilders$lambda_3;
  var tmp_6 = new BooleanComponentBuilder(tmp_5, ProductSpecificationBuilder$singleBuilders$lambda_4);
  var tmp_7 = ProductSpecificationBuilder$singleBuilders$lambda_5;
  var tmp_8 = new BooleanComponentBuilder(tmp_7, ProductSpecificationBuilder$singleBuilders$lambda_6);
  var tmp_9 = ProductSpecificationBuilder$singleBuilders$lambda_7;
  var tmp_10 = new BooleanComponentBuilder(tmp_9, ProductSpecificationBuilder$singleBuilders$lambda_8);
  var tmp_11 = ProductSpecificationBuilder$singleBuilders$lambda_9;
  var tmp_12 = new BooleanComponentBuilder(tmp_11, ProductSpecificationBuilder$singleBuilders$lambda_10);
  var tmp_13 = ProductSpecificationBuilder$singleBuilders$lambda_11;
  var tmp_14 = new BooleanComponentBuilder(tmp_13, ProductSpecificationBuilder$singleBuilders$lambda_12);
  var tmp_15 = ProductSpecificationBuilder$singleBuilders$lambda_13;
  var tmp_16 = new BooleanComponentBuilder(tmp_15, ProductSpecificationBuilder$singleBuilders$lambda_14);
  var tmp_17 = ProductSpecificationBuilder$singleBuilders$lambda_15;
  var tmp_18 = new BooleanComponentBuilder(tmp_17, ProductSpecificationBuilder$singleBuilders$lambda_16);
  var tmp_19 = ProductSpecificationBuilder$singleBuilders$lambda_17;
  var tmp_20 = new BooleanComponentBuilder(tmp_19, ProductSpecificationBuilder$singleBuilders$lambda_18);
  var tmp_21 = ProductSpecificationBuilder$singleBuilders$lambda_19;
  var tmp_22 = new BooleanComponentBuilder(tmp_21, ProductSpecificationBuilder$singleBuilders$lambda_20);
  var tmp_23 = ProductSpecificationBuilder$singleBuilders$lambda_21;
  var tmp_24 = new BooleanComponentBuilder(tmp_23, ProductSpecificationBuilder$singleBuilders$lambda_22);
  var tmp_25 = ProductSpecificationBuilder$singleBuilders$lambda_23;
  tmp.o5q_1 = listOf([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, tmp_18, tmp_20, tmp_22, tmp_24, new BooleanComponentBuilder(tmp_25, ProductSpecificationBuilder$singleBuilders$lambda_24), new ConnectorsComponentBuilder(), new ModelInfoComponentBuilder(), new ModelTransformComponentBuilder(), new RelativeConnectorsComponentBuilder(), new ColliderShapeComponentBuilder(), new MetaDataComponentBuilder(), new AllowedDoorPairsComponentBuilder(), new AutoAdaptHostComponentBuilder(), new LightComponentBuilder(), new PlacementZoneByHeightComponentBuilder(), new RecommendedInitialPositionFromFloorComponentBuilder(), new VisualLightSourceComponentBuilder(), new DragProjectionPointComponentBuilder(), new FunctionalMarginShapeComponentBuilder(), new FunctionalZonesLocalComponentBuilder(), new ProppingComponentBuilder(), new DragSurfacesComponentBuilder(), new ProductStructureComponentBuilder(), new CatalogSizeComponentBuilder(), new CommunicationSizeComponentBuilder()]);
  this.p5q_1 = listOf([new RequiredComponentsBuilder(), new AssemblyComponentsBuilder(itemRepository)]);
}
protoOf(ProductSpecificationBuilder).s5q = function (rangeItem) {
  var productComponent = new ProductComponent(rangeItem.id);
  var components = buildComponents(this, rangeItem);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = plus(components, productComponent);
  var tmp$ret$0 = copyToArray(this_0);
  return new ProductSpecification(tmp$ret$0);
};
function AllowedDoorPairsComponentBuilder() {
}
protoOf(AllowedDoorPairsComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.allowedDoorPairs;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.AllowedDoorPairsComponentBuilder.buildSingle.<anonymous>' call
    tmp = new AllowedDoorPairsComponent(tmp0_safe_receiver);
  }
  return tmp;
};
function buildAssemblyComponents($this, rangeItem, components) {
  var tmp0_safe_receiver = rangeItem.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parts;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toMutableList(tmp1_safe_receiver);
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.buildAssemblyComponents.<anonymous>' call
    var tmp0_safe_receiver_0 = components.assembly;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.buildAssemblyComponents.<anonymous>.<anonymous>' call
      tmp_0 = mapPartsToAssemblyStructureChildren($this, tmp2_safe_receiver, tmp0_safe_receiver_0, rangeItem.parameters.size);
    }
    tmp = tmp_0;
  }
  var tmp3_elvis_lhs = tmp;
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$4 = [];
    tmp_1 = new Pair(tmp$ret$4, emptyMap());
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  var _destruct__k2r9zo = tmp_1;
  var assemblyParts = _destruct__k2r9zo.tf();
  var partsMap = _destruct__k2r9zo.uf();
  return listOf([new AssemblyStructureComponent(assemblyParts), AssemblyPartsComponent_init_$Create$(partsMap)]);
}
function mapPartsToAssemblyStructureChildren($this, catalogParts, assemblyChildren, catalogSize) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var assemblyParts = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var partsMap = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = assemblyChildren.length;
  while (inductionVariable < last) {
    var element = assemblyChildren[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.mapPartsToAssemblyStructureChildren.<anonymous>' call
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var tmp0_iterator = catalogParts.k();
      while (tmp0_iterator.m()) {
        var item = tmp0_iterator.n();
        // Inline function 'com.ikea.range.ipex.range.builder.component.AssemblyComponentsBuilder.mapPartsToAssemblyStructureChildren.<anonymous>.<anonymous>' call
        if (item.partKey === element.partKey) {
          tmp$ret$3 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$3 = -1;
    }
    var partIndex = tmp$ret$3;
    var tmp;
    if (!(element.connector == null) && !(element.connectorOnHost == null)) {
      tmp = new AssemblyPartSnapInfo(element.connectorOnHost, element.connector);
    } else {
      tmp = null;
    }
    var snapInfo = tmp;
    if (partIndex > -1) {
      var part = catalogParts.p2(partIndex);
      var tmp_0;
      if (!(element.children == null)) {
        var tmp0_safe_receiver = $this.t5q_1.findItemDTO(part.id);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.parameters;
        var childCatalogSize = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size;
        tmp_0 = mapPartsToAssemblyStructureChildren($this, catalogParts, element.children, childCatalogSize);
      } else {
        tmp_0 = new Pair(null, null);
      }
      var _destruct__k2r9zo = tmp_0;
      var children = _destruct__k2r9zo.tf();
      var childrenParts = _destruct__k2r9zo.uf();
      if (childrenParts == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        partsMap.s2(childrenParts);
      }
      var tmp_1;
      if (!(element.position == null)) {
        var tmp_2;
        if (!(catalogSize == null)) {
          tmp_2 = element.position.applyToBox(Companion_getInstance_1().fromSize$default(catalogSize.vector));
        } else {
          tmp_2 = element.position.absoluteTransform;
        }
        tmp_1 = tmp_2;
      } else if (!(element.transform == null)) {
        tmp_1 = new Transform(new Vector(element.transform[0], element.transform[1], element.transform[2]), Companion_getInstance_0().s2w(new Degrees(element.transform[3]), new Degrees(element.transform[4]), new Degrees(element.transform[5])));
      } else {
        tmp_1 = Companion_getInstance().c1x_1;
      }
      var transform = tmp_1;
      var tmp3_elvis_lhs = element.locked;
      var assemblyPart = new AssemblyPart(element.partKey, transform, snapInfo, children, tmp3_elvis_lhs == null ? true : tmp3_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      var key = element.partKey;
      var value = part.id;
      partsMap.q2(key, value);
      assemblyParts.h(assemblyPart);
    } else {
      var tmp4_safe_receiver = element.position;
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.absoluteTransform;
      var transform_0 = tmp5_elvis_lhs == null ? Companion_getInstance().c1x_1 : tmp5_elvis_lhs;
      var tmp6_elvis_lhs = element.locked;
      var assemblyPart_0 = new AssemblyPart(element.partKey, transform_0, snapInfo, null, tmp6_elvis_lhs == null ? true : tmp6_elvis_lhs);
      // Inline function 'kotlin.collections.set' call
      var key_0 = element.partKey;
      partsMap.q2(key_0, '');
      assemblyParts.h(assemblyPart_0);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$5 = copyToArray(assemblyParts);
  return new Pair(tmp$ret$5, partsMap);
}
function AssemblyComponentsBuilder(itemRepository) {
  this.t5q_1 = itemRepository;
}
protoOf(AssemblyComponentsBuilder).r5q = function (item, components, commonData) {
  var tmp;
  if (!(components.assembly == null)) {
    tmp = buildAssemblyComponents(this, item, components);
  } else {
    tmp = emptyList();
  }
  return tmp;
};
function sam$kotlin_Comparator$0(function_0) {
  this.u5q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).md = function (a, b) {
  return this.u5q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.md(a, b);
};
protoOf(sam$kotlin_Comparator$0).s3 = function () {
  return this.u5q_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.s3(), other.s3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.s3());
};
function AutoAdaptGuestComponentBuilder$buildSingle$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
  var tmp0_safe_receiver = b.components;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.autoAdaptGroup;
  var tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.priority;
  // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
  var tmp0_safe_receiver_0 = a.components;
  var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.autoAdaptGroup;
  var tmp$ret$1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.priority;
  return compareValues(tmp, tmp$ret$1);
}
function AutoAdaptGuestComponentBuilder(itemRepository) {
  this.v5q_1 = itemRepository;
}
protoOf(AutoAdaptGuestComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.autoAdaptGroup;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.sortedByDescending' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.v5q_1.getAllItemDTOs();
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = element.components;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.autoAdaptGroup;
      if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.key) === tmp0_safe_receiver.key) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_0 = AutoAdaptGuestComponentBuilder$buildSingle$lambda;
    var tmp$ret$3 = new sam$kotlin_Comparator$0(tmp_0);
    var this_1 = sortedWith(destination, tmp$ret$3);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.k();
    while (tmp0_iterator.m()) {
      var item_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptGuestComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      var tmp$ret$5 = item_0.id;
      destination_0.h(tmp$ret$5);
    }
    var variants = copyToArray(destination_0);
    tmp = new AutoAdaptGuestComponent(variants, tmp0_safe_receiver.key);
  }
  return tmp;
};
function AutoAdaptHostComponentBuilder() {
}
protoOf(AutoAdaptHostComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.autoAdaptHost;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptHostComponentBuilder.buildSingle.<anonymous>' call
    var tmp0_safe_receiver_0 = item.parameters;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.size;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.AutoAdaptHostComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      var tmp0_elvis_lhs = tmp0_safe_receiver.hostZone;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        var tmp1_width = tmp1_safe_receiver.b2y_1;
        var tmp2_height = tmp1_safe_receiver.c2y_1;
        var tmp3_depth = tmp1_safe_receiver.d2y_1;
        tmp_1 = new DynamicRangeDimension(VOID, VOID, tmp3_depth, VOID, tmp2_height, VOID, VOID, VOID, tmp1_width);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var dim = tmp_1;
      tmp_0 = new AutoAdaptHostComponent(dim.getPolyhedronForSize(tmp1_safe_receiver));
    }
    tmp = tmp_0;
  }
  return tmp;
};
function BooleanComponentBuilder(builder, selector) {
  this.w5q_1 = builder;
  this.x5q_1 = selector;
}
protoOf(BooleanComponentBuilder).q5q = function (item, components, commonData) {
  var tmp;
  if (this.x5q_1(components)) {
    tmp = this.w5q_1();
  } else {
    tmp = null;
  }
  return tmp;
};
function CatalogSizeComponentBuilder() {
}
protoOf(CatalogSizeComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.CatalogSizeComponentBuilder.buildSingle.<anonymous>' call
    tmp = new CatalogSizeComponent(tmp1_safe_receiver);
  }
  return tmp;
};
function ColliderShapeComponentBuilder() {
}
protoOf(ColliderShapeComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.colliders;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (tmp0_safe_receiver.length === 0) {
      tmp_0 = null;
    } else {
      var tmp0_safe_receiver_0 = commonData.getColliders(tmp0_safe_receiver);
      var tmp_1;
      if (tmp0_safe_receiver_0 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.ColliderShapeComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        tmp_1 = new ColliderShapeComponent(tmp0_safe_receiver_0.polyhedron, tmp0_safe_receiver_0.ids);
      }
      return tmp_1;
    }
    return tmp_0;
  }
  return tmp;
};
function CommunicationSizeComponentBuilder() {
}
protoOf(CommunicationSizeComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.labels;
  var x = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f2('w');
  var tmp2_safe_receiver = item.parameters;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.labels;
  var y = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.f2('h');
  var tmp4_safe_receiver = item.parameters;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.labels;
  var z = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.f2('d');
  if (!(x == null) || !(y == null) || !(z == null)) {
    var tmp7_elvis_lhs = x == null ? null : toDouble(x);
    var tmp = tmp7_elvis_lhs == null ? 0.0 : tmp7_elvis_lhs;
    var tmp9_elvis_lhs = y == null ? null : toDouble(y);
    var tmp_0 = tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs;
    var tmp11_elvis_lhs = z == null ? null : toDouble(z);
    return new CommunicationSizeComponent(new Size(tmp, tmp_0, tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs));
  }
  return null;
};
function buildConnector($this, data, item) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp = tmp1_elvis_lhs == null ? new Size() : tmp1_elvis_lhs;
  return data.getConnectorForSize(tmp, ConnectorsComponentBuilder$buildConnector$lambda($this, data, item));
}
function addConnectorTags($this, data, item, connector) {
  var tmp0_safe_receiver = data.demands;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.addConnectorTags.<anonymous>' call
    var tmp0_safe_receiver_0 = item.parameters;
    connector.setDemands(convertMagicLabels($this, tmp0_safe_receiver, tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.labels).slice());
  }
  var tmp1_safe_receiver = data.offers;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.addConnectorTags.<anonymous>' call
    var tmp0_safe_receiver_1 = item.parameters;
    connector.setOffers(convertMagicLabels($this, tmp1_safe_receiver, tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.labels).slice());
  }
  var tmp;
  if (!(data.requireUpwardParent == null)) {
    var tmp_0 = data.requireUpwardParent;
    tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
  } else {
    tmp = false;
  }
  if (tmp) {
    connector.withTag(ConnectorTagConstants_instance.w2b_1);
  }
  var tmp_1;
  if (!(data.requireDownwardParent == null)) {
    var tmp_2 = data.requireDownwardParent;
    tmp_1 = (!(tmp_2 == null) ? typeof tmp_2 === 'boolean' : false) ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    connector.withTag(ConnectorTagConstants_instance.x2b_1);
  }
  return connector;
}
function convertMagicLabels($this, connectorLabels, parameterLabels) {
  var tmp;
  if (parameterLabels == null) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = connectorLabels.length;
    while (inductionVariable < last) {
      var element = connectorLabels[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.convertMagicLabels.<anonymous>' call
      if (contains(element, _Char___init__impl__6a9atx(123))) {
        // Inline function 'kotlin.error' call
        var message = 'magic failed because item has no labels';
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    tmp = connectorLabels;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(connectorLabels.length);
    var inductionVariable_0 = 0;
    var last_0 = connectorLabels.length;
    while (inductionVariable_0 < last_0) {
      var item = connectorLabels[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.convertMagicLabels.<anonymous>' call
      var tmp_0;
      try {
        var result = '';
        var curParam = null;
        var inductionVariable_1 = 0;
        var last_1 = charSequenceLength(item) - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var i = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            if (curParam == null && charSequenceGet(item, i) === _Char___init__impl__6a9atx(123))
              curParam = '';
            else if (!(curParam == null) && !(charSequenceGet(item, i) === _Char___init__impl__6a9atx(125)))
              curParam = curParam + toString_0(charSequenceGet(item, i));
            else if (!(curParam == null) && charSequenceGet(item, i) === _Char___init__impl__6a9atx(125)) {
              var tmp0_safe_receiver = parameterLabels.f2(curParam);
              var tmp_1;
              if (tmp0_safe_receiver == null) {
                tmp_1 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.convertMagicLabels.<anonymous>.<anonymous>' call
                tmp_1 = result + tmp0_safe_receiver;
              }
              var tmp1_elvis_lhs = tmp_1;
              var tmp_2;
              if (tmp1_elvis_lhs == null) {
                var message_0 = 'magic failed on ' + curParam;
                throw IllegalStateException_init_$Create$(toString(message_0));
              } else {
                tmp_2 = tmp1_elvis_lhs;
              }
              result = tmp_2;
              curParam = null;
            } else
              result = result + toString_0(charSequenceGet(item, i));
          }
           while (inductionVariable_1 <= last_1);
        tmp_0 = result;
      } catch ($p) {
        var tmp_3;
        if ($p instanceof Error_0) {
          var e = $p;
          tmp_3 = item;
        } else {
          throw $p;
        }
        tmp_0 = tmp_3;
      }
      var tmp$ret$2 = tmp_0;
      destination.h(tmp$ret$2);
    }
    tmp = copyToArray(destination);
  }
  return tmp;
}
function ConnectorsComponentBuilder$buildConnector$lambda(this$0, $data, $item) {
  return function (it) {
    addConnectorTags(this$0, $data, $item, it);
    return Unit_instance;
  };
}
function ConnectorsComponentBuilder() {
}
protoOf(ConnectorsComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.connectors;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'kotlin.collections.isEmpty' call
    if (tmp0_safe_receiver.length === 0) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.ConnectorsComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = buildConnector(this, element, item);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
      var tmp$ret$5 = copyToArray(destination);
      tmp_0 = new ConnectorsComponent(tmp$ret$5);
    }
    return tmp_0;
  }
  return tmp;
};
function DragProjectionPointComponentBuilder() {
}
protoOf(DragProjectionPointComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.DragProjectionPointComponentBuilder.buildSingle.<anonymous>' call
    var tmp0_safe_receiver_0 = components.dragProjectionPoint;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.DragProjectionPointComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      var point = tmp0_safe_receiver_0.applyToBox(Companion_getInstance_1().fromSize$default(tmp1_safe_receiver.vector)).position;
      tmp_0 = new DragProjectionPointComponent(point);
    }
    tmp = tmp_0;
  }
  return tmp;
};
function generateDragSurface($this, dragData, size, collider) {
  var tmp;
  if (dragData.sameAsCollider) {
    var tmp_0;
    if (collider == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.generateDragSurface.<anonymous>' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = [new DragSurface(collider, null)];
    }
    tmp = tmp_0;
  } else {
    var tmp1_safe_receiver = dragData.surfaces;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.generateDragSurface.<anonymous>' call
        var tmp0_safe_receiver = element.generateDragSurface(size);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver);
        }
      }
      tmp_1 = destination;
    }
    var tmp2_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_2 = copyToArray(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_2;
    var tmp_3;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_3 = [];
    } else {
      tmp_3 = tmp3_elvis_lhs;
    }
    var polyhedronForSurfaces = tmp_3;
    var tmp_4;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(polyhedronForSurfaces.length === 0)) {
      tmp_4 = polyhedronForSurfaces;
    } else {
      tmp_4 = null;
    }
    tmp = tmp_4;
  }
  return tmp;
}
function DragSurfacesComponentBuilder() {
}
protoOf(DragSurfacesComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>' call
    var tmp0_safe_receiver_0 = components.dragSurfaces;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_1 = commonData.getColliders(components.colliders);
      var tmp_1;
      if (tmp0_safe_receiver_1 == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>' call
        var dragSurfaces = generateDragSurface(this, tmp0_safe_receiver_0, tmp1_safe_receiver, tmp0_safe_receiver_1.polyhedron);
        var tmp_2;
        if (dragSurfaces == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'com.ikea.range.ipex.range.builder.component.DragSurfacesComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          tmp_2 = new DragSurfacesComponent(dragSurfaces, false);
        }
        tmp_1 = tmp_2;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  }
  return tmp;
};
function FunctionalMarginShapeComponentBuilder() {
}
protoOf(FunctionalMarginShapeComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.functionalMargin;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalMarginShapeComponentBuilder.buildSingle.<anonymous>' call
    tmp = new FunctionalMarginShapeComponent(tmp0_safe_receiver.toMargin());
  }
  return tmp;
};
function FunctionalZonesLocalComponentBuilder() {
}
protoOf(FunctionalZonesLocalComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = item.parameters;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>' call
    var tmp0_safe_receiver_0 = components.functionalZones;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(tmp0_safe_receiver_0.length);
      var inductionVariable = 0;
      var last = tmp0_safe_receiver_0.length;
      while (inductionVariable < last) {
        var item_0 = tmp0_safe_receiver_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.builder.component.FunctionalZonesLocalComponentBuilder.buildSingle.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new FunctionalZone(item_0.id, item_0.layer, commonData.getPolyhedronForSize(item_0.dimension, tmp1_safe_receiver));
        destination.h(tmp$ret$0);
      }
      var tmp$ret$3 = copyToArray(destination);
      tmp_0 = new FunctionalZonesLocalComponent(tmp$ret$3);
    }
    tmp = tmp_0;
  }
  return tmp;
};
function LightComponentBuilder() {
}
protoOf(LightComponentBuilder).q5q = function (item, components, commonData) {
  var tmp;
  if (components.outerLight === true) {
    tmp = new LightComponent('outer');
  } else if (components.innerLight === true) {
    tmp = new LightComponent('inner');
  } else {
    tmp = null;
  }
  return tmp;
};
function MetaDataComponentBuilder() {
}
protoOf(MetaDataComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.meta;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.MetaDataComponentBuilder.buildSingle.<anonymous>' call
    tmp = new MetaDataComponent(tmp0_safe_receiver);
  }
  return tmp;
};
function ModelInfoComponentBuilder() {
}
protoOf(ModelInfoComponentBuilder).q5q = function (item, components, commonData) {
  // Inline function 'kotlin.text.isNullOrEmpty' call
  var this_0 = components.modelURI;
  // Inline function 'kotlin.contracts.contract' call
  if (!(this_0 == null || charSequenceLength(this_0) === 0)) {
    return new ModelInfoComponent(commonData.modelRootURL, components.modelURI, '');
  }
  return null;
};
function ModelTransformComponentBuilder() {
}
protoOf(ModelTransformComponentBuilder).q5q = function (item, components, commonData) {
  // Inline function 'kotlin.text.isNullOrEmpty' call
  var this_0 = components.modelURI;
  // Inline function 'kotlin.contracts.contract' call
  if (this_0 == null || charSequenceLength(this_0) === 0) {
    return null;
  }
  var tmp0_safe_receiver = components.modelTransform;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.ModelTransformComponentBuilder.buildSingle.<anonymous>' call
    tmp = new ModelTransformComponent(tmp0_safe_receiver);
  }
  return tmp;
};
function PlacementZoneByHeightComponentBuilder() {
}
protoOf(PlacementZoneByHeightComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.placementZoneByHeight;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.PlacementZoneByHeightComponentBuilder.buildSingle.<anonymous>' call
    tmp = new PlacementZoneByHeightComponent(tmp0_safe_receiver.minY, tmp0_safe_receiver.maxY);
  }
  return tmp;
};
function PolyhedronColliderIdsPair(polyhedron, ids) {
  this.polyhedron = polyhedron;
  this.ids = ids;
}
protoOf(PolyhedronColliderIdsPair).p1x = function () {
  return this.polyhedron;
};
protoOf(PolyhedronColliderIdsPair).q1x = function () {
  return this.ids;
};
protoOf(PolyhedronColliderIdsPair).tf = function () {
  return this.polyhedron;
};
protoOf(PolyhedronColliderIdsPair).uf = function () {
  return this.ids;
};
protoOf(PolyhedronColliderIdsPair).y5q = function (polyhedron, ids) {
  return new PolyhedronColliderIdsPair(polyhedron, ids);
};
protoOf(PolyhedronColliderIdsPair).copy = function (polyhedron, ids, $super) {
  polyhedron = polyhedron === VOID ? this.polyhedron : polyhedron;
  ids = ids === VOID ? this.ids : ids;
  return this.y5q(polyhedron, ids);
};
protoOf(PolyhedronColliderIdsPair).toString = function () {
  return 'PolyhedronColliderIdsPair(polyhedron=' + toString(this.polyhedron) + ', ids=' + toString(this.ids) + ')';
};
protoOf(PolyhedronColliderIdsPair).hashCode = function () {
  var result = hashCode(this.polyhedron);
  result = imul(result, 31) + hashCode(this.ids) | 0;
  return result;
};
protoOf(PolyhedronColliderIdsPair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PolyhedronColliderIdsPair))
    return false;
  var tmp0_other_with_cast = other instanceof PolyhedronColliderIdsPair ? other : THROW_CCE();
  if (!equals(this.polyhedron, tmp0_other_with_cast.polyhedron))
    return false;
  if (!equals(this.ids, tmp0_other_with_cast.ids))
    return false;
  return true;
};
function buildProductStructureComponent($this, productStructure, sizeAABB, parts) {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = productStructure.length;
  while (inductionVariable < last) {
    var element = productStructure[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>' call
      var tmp;
      if (parts == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var inductionVariable_0 = 0;
          var last_0 = parts.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = parts[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>.<anonymous>' call
            if (element_0.partKey === element.partKey) {
              tmp$ret$1 = element_0;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp = tmp$ret$1;
      }
      var tmp1_safe_receiver = tmp;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.id;
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        tmp$ret$3 = null;
        break $l$block_0;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      var productRef = tmp_0;
      var tmp3_safe_receiver = element.snap;
      var tmp_1;
      if (tmp3_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildProductStructureComponent.<anonymous>.<anonymous>' call
        tmp_1 = new ProductStructureConnection(tmp3_safe_receiver.offeringPartKey, tmp3_safe_receiver.demandingConnector, tmp3_safe_receiver.offeringConnector);
      }
      tmp$ret$3 = new ProductStructureItem(element.partKey, productRef, tmp_1, element.transform.applyToBox(sizeAABB));
    }
    var tmp0_safe_receiver = tmp$ret$3;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      destination.h(tmp0_safe_receiver);
    }
  }
  var tmp$ret$9 = copyToArray(destination);
  return new ProductStructureComponent(tmp$ret$9);
}
function ProductStructureComponentBuilder() {
}
protoOf(ProductStructureComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.productStructure;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.ProductStructureComponentBuilder.buildSingle.<anonymous>' call
    var tmp0_safe_receiver_0 = item.parameters;
    var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.size;
    var size = tmp1_elvis_lhs == null ? new Size() : tmp1_elvis_lhs;
    var tmp_0 = Companion_getInstance_1().fromSize$default(size.vector);
    var tmp2_safe_receiver = item.parameters;
    tmp = buildProductStructureComponent(this, tmp0_safe_receiver, tmp_0, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.parts);
  }
  return tmp;
};
function ProppingComponentBuilder() {
}
protoOf(ProppingComponentBuilder).q5q = function (item, components, commonData) {
  var tmp;
  if (components.propping === true) {
    tmp = new ProppingComponent();
  } else {
    tmp = null;
  }
  return tmp;
};
function RecommendedInitialPositionFromFloorComponentBuilder() {
}
protoOf(RecommendedInitialPositionFromFloorComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.recommendedInitialPositionFromFloor;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.RecommendedInitialPositionFromFloorComponentBuilder.buildSingle.<anonymous>' call
    tmp = new RecommendedInitialPositionFromFloorComponent(tmp0_safe_receiver);
  }
  return tmp;
};
function getRelativeConnectorData($this, item, components) {
  var tmp0_safe_receiver = item.parameters;
  var tmp;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size) == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_safe_receiver_0 = components.connectors;
    var tmp_0;
    if (tmp0_safe_receiver_0 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp0_safe_receiver_0.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.getRelativeConnectorData.<anonymous>.<anonymous>' call
        if (element.isRelativeToBounds()) {
          destination.h(element);
        }
      }
      tmp_0 = destination;
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp1_safe_receiver, 10));
      var tmp0_iterator = tmp1_safe_receiver.k();
      while (tmp0_iterator.m()) {
        var item_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.getRelativeConnectorData.<anonymous>.<anonymous>' call
        var tmp$ret$3 = item_0.createRelativeConnectorData(item.parameters.size);
        destination_0.h(tmp$ret$3);
      }
      tmp_1 = destination_0;
    }
    var tmp2_safe_receiver = tmp_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_2 = copyToArray(tmp2_safe_receiver);
    }
    var res = tmp_2;
    var tmp_3;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_4;
    if (res == null) {
      tmp_4 = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_4 = res.length === 0;
    }
    if (tmp_4) {
      tmp_3 = null;
    } else {
      tmp_3 = res;
    }
    return tmp_3;
  }
  return tmp;
}
function RelativeConnectorsComponentBuilder() {
}
protoOf(RelativeConnectorsComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = getRelativeConnectorData(this, item, components);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.RelativeConnectorsComponentBuilder.buildSingle.<anonymous>' call
    tmp = new RelativeConnectorsComponent(tmp0_safe_receiver);
  }
  return tmp;
};
function RequiredComponentsBuilder() {
}
protoOf(RequiredComponentsBuilder).r5q = function (item, components, commonData) {
  return listOf([new ConnectionRootComponent(), new DisplayNameComponent(item.description)]);
};
function VisualLightSourceComponentBuilder() {
}
protoOf(VisualLightSourceComponentBuilder).q5q = function (item, components, commonData) {
  var tmp0_safe_receiver = components.visualLightSource;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.builder.component.VisualLightSourceComponentBuilder.buildSingle.<anonymous>' call
    tmp = new VisualLightSourceComponent(tmp0_safe_receiver.type, tmp0_safe_receiver.intensity, tmp0_safe_receiver.colorTemperature);
  }
  return tmp;
};
function AmendableCatalog$Companion$jsonParser$lambda($this$Json) {
  $this$Json.s17_1 = true;
  $this$Json.r17_1 = true;
  return Unit_instance;
}
function cleanupAndGetItemsAffectedByAmend($this, amendedItems) {
  // Inline function 'kotlin.collections.isEmpty' call
  var repositoryWasEmpty = $this.h5r_1.getAllItemDTOs().length === 0;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = amendedItems.length;
  while (inductionVariable < last) {
    var element = amendedItems[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
    $this.h5r_1.set(element.id, element);
  }
  if (repositoryWasEmpty) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(amendedItems.length);
    var inductionVariable_0 = 0;
    var last_0 = amendedItems.length;
    while (inductionVariable_0 < last_0) {
      var item = amendedItems[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      var tmp$ret$1 = item.id;
      destination.h(tmp$ret$1);
    }
    var itemIdsToResolve = copyToArray(destination);
    $this.itemRepository.clear(itemIdsToResolve);
    return toMutableList(amendedItems);
  } else {
    var itemsToResolve = getItemsToResolve($this, amendedItems);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(itemsToResolve, 10));
    var tmp0_iterator = itemsToResolve.k();
    while (tmp0_iterator.m()) {
      var item_0 = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.cleanupAndGetItemsAffectedByAmend.<anonymous>' call
      var tmp$ret$5 = item_0.id;
      destination_0.h(tmp$ret$5);
    }
    var itemIdsToResolve_0 = copyToArray(destination_0);
    $this.itemRepository.clear(itemIdsToResolve_0);
    return toMutableList_0(itemsToResolve);
  }
}
function getItemsToResolve($this, items) {
  var allDTOs = $this.h5r_1.getAllItemDTOs();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var parentToChildrenMap = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = allDTOs.length;
  while (inductionVariable < last) {
    var element = allDTOs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsToResolve.<anonymous>' call
    var tmp0_safe_receiver = element.inherits;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = 0;
      var last_0 = tmp0_safe_receiver.length;
      while (inductionVariable_0 < last_0) {
        var element_0 = tmp0_safe_receiver[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsToResolve.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.set' call
        var tmp0_safe_receiver_0 = parentToChildrenMap.f2(element_0);
        var tmp;
        if (tmp0_safe_receiver_0 == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.plus' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$4 = [element.id];
          tmp = tmp0_safe_receiver_0.concat(tmp$ret$4);
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = [element.id];
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var value = tmp_0;
        parentToChildrenMap.q2(element_0, value);
      }
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(items.length);
  var inductionVariable_1 = 0;
  var last_1 = items.length;
  while (inductionVariable_1 < last_1) {
    var item = items[inductionVariable_1];
    inductionVariable_1 = inductionVariable_1 + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsToResolve.<anonymous>' call
    var tmp$ret$9 = item.id;
    destination.h(tmp$ret$9);
  }
  var tmp$ret$12 = copyToArray(destination);
  var affected_0 = affected($this, tmp$ret$12, parentToChildrenMap);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$();
  var inductionVariable_2 = 0;
  var last_2 = allDTOs.length;
  while (inductionVariable_2 < last_2) {
    var element_1 = allDTOs[inductionVariable_2];
    inductionVariable_2 = inductionVariable_2 + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getItemsToResolve.<anonymous>' call
    if (affected_0.s(element_1.id)) {
      destination_0.h(element_1);
    }
  }
  return destination_0;
}
function affected($this, items, parentToChildrenMap) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var inductionVariable = 0;
  var last = items.length;
  while (inductionVariable < last) {
    var element = items[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.affected.<anonymous>' call
    var children = parentToChildrenMap.f2(element);
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    if (children == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = children.length === 0;
    }
    if (!tmp_0) {
      tmp = plus(affected($this, children, parentToChildrenMap), element);
    } else {
      tmp = listOf_0(element);
    }
    var list = tmp;
    addAll(destination, list);
  }
  return destination;
}
function collectMissingAncestors($this, ri) {
  var tmp0_safe_receiver = ri.inherits;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingAncestors.<anonymous>' call
      var tmp0_safe_receiver_0 = $this.h5r_1.findItemDTO(element);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingAncestors.<anonymous>.<anonymous>' call
        tmp_0 = collectMissingAncestors($this, tmp0_safe_receiver_0);
      }
      var tmp1_elvis_lhs = tmp_0;
      var list = tmp1_elvis_lhs == null ? listOf_0(element) : tmp1_elvis_lhs;
      addAll(destination, list);
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs_0 = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs_0 == null) {
    // Inline function 'kotlin.collections.listOf' call
    tmp_1 = emptyList();
  } else {
    tmp_1 = tmp1_elvis_lhs_0;
  }
  return tmp_1;
}
function collectMissingLabels($this, ri) {
  var tmp0_safe_receiver = ri.components;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.connectors;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = tmp1_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp1_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.plus' call
      var tmp0_elvis_lhs = element.offers;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [];
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var this_0 = tmp_0;
      var tmp1_elvis_lhs = element.demands;
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = [];
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var elements = tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      var offersDemands = this_0.concat(elements);
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(offersDemands.length);
      var inductionVariable_0 = 0;
      var last_0 = offersDemands.length;
      while (inductionVariable_0 < last_0) {
        var item = offersDemands[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$8 = Regex_init_$Create$('\\{.+?\\}').sc(item);
        destination_0.h(tmp$ret$8);
      }
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_1 = ArrayList_init_$Create$();
      var tmp0_iterator = destination_0.k();
      while (tmp0_iterator.m()) {
        var element_0 = tmp0_iterator.n();
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
        var list = map(element_0, AmendableCatalog$collectMissingLabels$lambda);
        addAll_0(destination_1, list);
      }
      var this_1 = distinct(destination_1);
      var o = copyToArray(this_1);
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$();
      var inductionVariable_1 = 0;
      var last_1 = o.length;
      while (inductionVariable_1 < last_1) {
        var element_1 = o[inductionVariable_1];
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.collectMissingLabels.<anonymous>.<anonymous>.<anonymous>' call
        var tmp0_safe_receiver_0 = ri.parameters;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.labels;
        if ((tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.f2(element_1)) == null) {
          destination_2.h(element_1);
        }
      }
      var list_0 = destination_2;
      addAll(destination, list_0);
    }
    tmp = destination;
  }
  var tmp2_elvis_lhs = tmp;
  var tmp_2;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.collections.listOf' call
    tmp_2 = emptyList();
  } else {
    tmp_2 = tmp2_elvis_lhs;
  }
  return tmp_2;
}
function Companion() {
  Companion_instance_0 = this;
  var tmp = this;
  tmp.q5r_1 = Json(VOID, AmendableCatalog$Companion$jsonParser$lambda);
}
var Companion_instance_0;
function Companion_getInstance_7() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function AmendableCatalog$collectMissingLabels$lambda(it) {
  return replace(replace(it.c2(), '{', ''), '}', '');
}
function AmendableCatalog(modelRootURL) {
  Companion_getInstance_7();
  modelRootURL = modelRootURL === VOID ? null : modelRootURL;
  IPEXRangeFormatCatalog.call(this, modelRootURL);
  this.h5r_1 = new ItemRepository();
}
protoOf(AmendableCatalog).addItem = function (itemJson) {
  var rangeItem = this.l5r_1.r5r(itemJson, this.p5r_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [rangeItem];
  return firstOrNull(this.s5r(cleanupAndGetItemsAffectedByAmend(this, tmp$ret$2)));
};
protoOf(AmendableCatalog).addItems = function (itemsJson) {
  var rangeItems = toMutableList(this.l5r_1.t5r(itemsJson, this.p5r_1));
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$0 = copyToArray(rangeItems);
  return this.s5r(cleanupAndGetItemsAffectedByAmend(this, tmp$ret$0));
};
protoOf(AmendableCatalog).addItemsFromArray = function (items) {
  return this.s5r(cleanupAndGetItemsAffectedByAmend(this, items));
};
protoOf(AmendableCatalog).getResolvedItem = function (id) {
  var tmp0_safe_receiver = this.itemRepository.findItemDTO(id);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getResolvedItem.<anonymous>' call
    tmp = Companion_getInstance_7().q5r_1.v16(Companion_getInstance_13().z18(), tmp0_safe_receiver);
  }
  return tmp;
};
protoOf(AmendableCatalog).getUnresolvedItem = function (id) {
  var tmp0_safe_receiver = this.h5r_1.findItemDTO(id);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.getUnresolvedItem.<anonymous>' call
    tmp = Companion_getInstance_7().q5r_1.v16(Companion_getInstance_13().z18(), tmp0_safe_receiver);
  }
  return tmp;
};
protoOf(AmendableCatalog).validateProductItem = function (id) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var errors = ArrayList_init_$Create$();
  var tmp0_safe_receiver = this.itemRepository.findItemDTO(id);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_safe_receiver_0 = tmp0_safe_receiver.components;
    var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.product;
    if (tmp1_safe_receiver == null)
      null;
    else {
      $l$block: {
        // Inline function 'com.ikea.core.utils.orElse' call
        if (tmp1_safe_receiver == null) {
          // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
          errors.h('ITEM_IS_NOT_A_PRODUCT:' + id);
          break $l$block;
        }
      }
    }
    var tmp2_safe_receiver = tmp0_safe_receiver.components;
    if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.product) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_1 = tmp0_safe_receiver.parameters;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.size;
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        $l$block_0: {
          // Inline function 'com.ikea.core.utils.orElse' call
          if (tmp1_safe_receiver_0 == null) {
            // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>.<anonymous>' call
            errors.h('ITEM_HAS_NO_SIZE:' + id);
            break $l$block_0;
          }
        }
      }
      var tmp2_safe_receiver_0 = tmp0_safe_receiver.components.modelURI;
      var tmp_0;
      if (tmp2_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$6;
        $l$block_1: {
          // Inline function 'com.ikea.core.utils.orElse' call
          if (tmp2_safe_receiver_0 == null) {
            // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>.<anonymous>' call
            tmp$ret$6 = errors.h('ITEM_HAS_NO_MODEL:' + id);
            break $l$block_1;
          }
          tmp$ret$6 = tmp2_safe_receiver_0;
        }
        tmp_0 = tmp$ret$6;
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = collectMissingLabels(this, tmp0_safe_receiver).k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
      errors.h('MAGIC_LABEL_MISSING_IN_PARAMETERS:' + id + ':' + element);
    }
    tmp = Unit_instance;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver_1 = this.h5r_1.findItemDTO(id);
    var tmp_2;
    if (tmp2_safe_receiver_1 == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = collectMissingAncestors(this, tmp2_safe_receiver_1).k();
      while (tmp0_iterator_0.m()) {
        var element_0 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.range.ipex.range.catalog.AmendableCatalog.validateProductItem.<anonymous>.<anonymous>' call
        errors.h('PARENT_ITEM_MISSING:' + id + ':' + element_0);
      }
      tmp_2 = Unit_instance;
    }
    tmp_1 = tmp_2;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  if (tmp_1 == null)
    errors.h('MISSING_ITEM:' + id);
  var tmp_3;
  if (errors.o() > 0) {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_3 = copyToArray(errors);
  } else {
    tmp_3 = null;
  }
  return tmp_3;
};
protoOf(AmendableCatalog).clearItems = function (itemIds) {
  protoOf(IPEXRangeFormatCatalog).clearItems.call(this, itemIds);
  this.h5r_1.clear(itemIds);
};
function extractVersionForThisCatalog($this, catalogVersions) {
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = catalogVersions.length;
    while (inductionVariable < last) {
      var element = catalogVersions[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.extractVersionForThisCatalog.<anonymous>' call
      if (element.rangeId === $this.rangeId()) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.version;
}
function addProductParams($this, specification, item, providedParams) {
  var tmp;
  if (!(providedParams == null)) {
    tmp = specification.addComponent(new ProductParamsComponent(providedParams));
  } else {
    var tmp0_safe_receiver = item.parameters;
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.size) == null)) {
      tmp = specification.addComponent(new ProductParamsComponent(new ProductParams(item.parameters.size)));
    } else {
      tmp = specification;
    }
  }
  return tmp;
}
function applyParams($this, item, params) {
  if (params == null)
    return item;
  var tmp = Companion_getInstance_2();
  var tmp1_safe_receiver = item.parameters;
  var newSize = tmp.y2z(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.size, params);
  var tmp2_safe_receiver = item.parameters;
  var tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.labels;
  var tmp3_safe_receiver = item.parameters;
  return new RangeItemDTO(item.id, item.description, item.inherits, new ItemParametersDTO(newSize, tmp_0, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.parts), item.components);
}
function resolveInheritanceAndAdd($this, untouchedItem) {
  try {
    var withInheritance = $this.n5r_1.a5s(untouchedItem);
    $this.itemRepository.set(untouchedItem.id, withInheritance);
    return withInheritance;
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      var tmp = Companion_getInstance_8().b5s_1;
      tmp.warn(IPEXRangeFormatCatalog$resolveInheritanceAndAdd$lambda(e));
    } else {
      throw $p;
    }
  }
  return null;
}
function Companion_0() {
  Companion_instance_1 = this;
  this.b5s_1 = LoggerState_getInstance().g1v('IPEXRangeFormatCatalog');
}
var Companion_instance_1;
function Companion_getInstance_8() {
  if (Companion_instance_1 == null)
    new Companion_0();
  return Companion_instance_1;
}
function IPEXRangeFormatCatalog$productSpecification$lambda($e) {
  return function () {
    return $e.message;
  };
}
function IPEXRangeFormatCatalog$resolveItems$lambda(this$0) {
  return function (it) {
    return !(this$0.itemRepository.findItemDTO(it.id) == null);
  };
}
function IPEXRangeFormatCatalog$resolveItems$lambda$lambda($e) {
  return function () {
    return 'Failed to resolve item. ' + $e.message;
  };
}
function IPEXRangeFormatCatalog$resolveItems$lambda_0($items, this$0, $resolvedItems) {
  return function (item) {
    try {
      $items.j2(item);
      var tmp0_safe_receiver = resolveInheritanceAndAdd(this$0, item);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>.<anonymous>' call
        $resolvedItems.h(tmp0_safe_receiver);
      }
    } catch ($p) {
      if ($p instanceof Error_0) {
        var e = $p;
        var tmp = Companion_getInstance_8().b5s_1;
        tmp.warn(IPEXRangeFormatCatalog$resolveItems$lambda$lambda(e));
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  };
}
function IPEXRangeFormatCatalog$resolveItems$lambda$lambda_0(it) {
  return it.id;
}
function IPEXRangeFormatCatalog$resolveItems$lambda_1($items) {
  return function () {
    return 'Inheritance could not be resolved for ' + joinToString($items, VOID, VOID, VOID, VOID, VOID, IPEXRangeFormatCatalog$resolveItems$lambda$lambda_0);
  };
}
function IPEXRangeFormatCatalog$resolveInheritanceAndAdd$lambda($e) {
  return function () {
    return toString_1($e.message);
  };
}
function ItemRepository$getAllItemDTOs$ref($boundThis) {
  var l = function () {
    return $boundThis.getAllItemDTOs();
  };
  l.callableName = 'getAllItemDTOs';
  return l;
}
function IPEXRangeFormatCatalog(modelRootURL) {
  Companion_getInstance_8();
  modelRootURL = modelRootURL === VOID ? null : modelRootURL;
  this.modelRootURL = modelRootURL;
  this.i5r_1 = true;
  this.j5r_1 = 'ipex-range';
  this.k5r_1 = '0';
  this.itemRepository = new ItemRepository();
  this.l5r_1 = new ItemParser();
  this.m5r_1 = new ProductSpecificationBuilder(this.itemRepository, this.modelRootURL);
  this.n5r_1 = new InheritanceResolver(this.itemRepository);
  var tmp = this;
  // Inline function 'kotlin.collections.mutableSetOf' call
  tmp.o5r_1 = LinkedHashSet_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_0.p5r_1 = ArrayList_init_$Create$();
  var tmp_1 = this;
  tmp_1.getAllItemDTOs = ItemRepository$getAllItemDTOs$ref(this.itemRepository);
}
protoOf(IPEXRangeFormatCatalog).i5o = function () {
  return this.modelRootURL;
};
protoOf(IPEXRangeFormatCatalog).s1t = function () {
  return this.i5r_1;
};
protoOf(IPEXRangeFormatCatalog).rangeId = function () {
  return this.j5r_1;
};
protoOf(IPEXRangeFormatCatalog).rangeVersion = function () {
  return this.k5r_1;
};
protoOf(IPEXRangeFormatCatalog).v5r = function () {
  return this.itemRepository;
};
protoOf(IPEXRangeFormatCatalog).w5r = function () {
  return this.l5r_1;
};
protoOf(IPEXRangeFormatCatalog).x5r = function () {
  return this.p5r_1;
};
protoOf(IPEXRangeFormatCatalog).addInterceptor = function (interceptor) {
  this.o5r_1.h(interceptor);
};
protoOf(IPEXRangeFormatCatalog).removeInterceptor = function (interceptor) {
  this.o5r_1.j2(interceptor);
};
protoOf(IPEXRangeFormatCatalog).beforeDeserialize = function (json, catalogVersions) {
  var res = json;
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.o5r_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeDeserialize.<anonymous>' call
    res = element.beforeDeserialize(res, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
  return res;
};
protoOf(IPEXRangeFormatCatalog).beforeBuildingEntities = function (serializableTree, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.o5r_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeBuildingEntities.<anonymous>' call
    element.beforeBuildingEntities(serializableTree, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(IPEXRangeFormatCatalog).beforeParsingComponents = function (serializableTree, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.o5r_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.beforeParsingComponents.<anonymous>' call
    element.beforeParsingComponents(serializableTree, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(IPEXRangeFormatCatalog).afterDeserializeComplete = function (root, catalogVersions) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = this.o5r_1.k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.afterDeserializeComplete.<anonymous>' call
    element.afterDeserializeComplete(root, extractVersionForThisCatalog(this, catalogVersions), catalogVersions);
  }
};
protoOf(IPEXRangeFormatCatalog).addCustomComponentParser = function (parser) {
  this.p5r_1.h(parser);
};
protoOf(IPEXRangeFormatCatalog).removeCustomComponentParser = function (parser) {
  this.p5r_1.j2(parser);
};
protoOf(IPEXRangeFormatCatalog).t1t = function (productRef, params) {
  var tmp0_elvis_lhs = this.itemRepository.findItemDTO(productRef);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var item = tmp;
  var itemWithAppliedParams = applyParams(this, item, params);
  try {
    var specification = this.m5r_1.s5q(itemWithAppliedParams);
    return addProductParams(this, specification, item, params);
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      var tmp_0 = Companion_getInstance_8().b5s_1;
      tmp_0.warn(IPEXRangeFormatCatalog$productSpecification$lambda(e));
    } else {
      throw $p;
    }
  }
  return null;
};
protoOf(IPEXRangeFormatCatalog).allProductRefs = function () {
  return this.itemRepository.getAllProductNames();
};
protoOf(IPEXRangeFormatCatalog).allRefs = function () {
  return this.itemRepository.getAllNames();
};
protoOf(IPEXRangeFormatCatalog).toString = function () {
  return 'IPEX Range Format Catalog';
};
protoOf(IPEXRangeFormatCatalog).addItem = function (itemJson) {
  var rangeItem = this.l5r_1.r5r(itemJson, this.p5r_1);
  return firstOrNull(this.s5r(mutableListOf([rangeItem])));
};
protoOf(IPEXRangeFormatCatalog).addItems = function (itemsJson) {
  var rangeItems = toMutableList(this.l5r_1.t5r(itemsJson, this.p5r_1));
  return this.s5r(rangeItems);
};
protoOf(IPEXRangeFormatCatalog).addItemsFromArray = function (items) {
  return this.s5r(toMutableList(items));
};
protoOf(IPEXRangeFormatCatalog).s5r = function (items) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var resolvedItems = ArrayList_init_$Create$();
  removeAll(items, IPEXRangeFormatCatalog$resolveItems$lambda(this));
  var resolveAndRemoveItem = IPEXRangeFormatCatalog$resolveItems$lambda_0(items, this, resolvedItems);
  $l$loop: while (items.o() > 0) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = items.k();
    while (tmp0_iterator.m()) {
      var element = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>' call
      if (this.n5r_1.c5s(element)) {
        destination.h(element);
      }
    }
    var resolvable = destination;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = resolvable.k();
    while (tmp0_iterator_0.m()) {
      var element_0 = tmp0_iterator_0.n();
      // Inline function 'com.ikea.range.ipex.range.catalog.IPEXRangeFormatCatalog.resolveItems.<anonymous>' call
      resolveAndRemoveItem(element_0);
    }
    if (resolvable.r()) {
      break $l$loop;
    }
  }
  if (items.o() > 0) {
    var tmp = Companion_getInstance_8().b5s_1;
    tmp.warn(IPEXRangeFormatCatalog$resolveItems$lambda_1(items));
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(resolvedItems);
};
protoOf(IPEXRangeFormatCatalog).clearItems = function (itemIds) {
  this.itemRepository.clear(itemIds);
};
protoOf(IPEXRangeFormatCatalog).y5r = function () {
  return this.getAllItemDTOs;
};
function resolve($this, itemDTO) {
  var tmp;
  if (itemDTO.inherits == null) {
    tmp = itemDTO;
  } else {
    var resultingItem = itemDTO;
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = reversedArray(itemDTO.inherits);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.InheritanceResolver.resolve.<anonymous>' call
      var tmp0_elvis_lhs = $this.z5r_1.findItemDTO(element);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        throw Exception_init_$Create$("Item '" + itemDTO.id + "' extends '" + element + "' that cannot be found");
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var parentItem = tmp_0;
      resultingItem = resultingItem.inherit(parentItem);
    }
    tmp = resultingItem;
  }
  return tmp;
}
function InheritanceResolver(itemRepository) {
  this.z5r_1 = itemRepository;
}
protoOf(InheritanceResolver).a5s = function (itemDTO) {
  return resolve(this, itemDTO);
};
protoOf(InheritanceResolver).c5s = function (itemDTO) {
  var tmp0_safe_receiver = itemDTO.inherits;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.range.ipex.range.catalog.InheritanceResolver.inheritanceIsResolvable.<anonymous>' call
        var item = this.z5r_1.findItemDTO(element);
        if (!(!(item == null) && this.c5s(item))) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    tmp = tmp$ret$1;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
};
function ItemRepository() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.d5s_1 = LinkedHashMap_init_$Create$();
}
protoOf(ItemRepository).findItemDTO = function (name) {
  return this.d5s_1.f2(name);
};
protoOf(ItemRepository).getAllItemDTOs = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.d5s_1.h2();
  return copyToArray(this_0);
};
protoOf(ItemRepository).getAllNames = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = this.d5s_1.g2();
  return copyToArray(this_0);
};
protoOf(ItemRepository).getAllProductNames = function () {
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = this.d5s_1;
  var destination = LinkedHashMap_init_$Create$();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.catalog.ItemRepository.getAllProductNames.<anonymous>' call
    // Inline function 'com.ikea.core.utils.isNotNull' call
    var tmp0_safe_receiver = element.c2().components;
    if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.product) == null)) {
      destination.q2(element.b2(), element.c2());
    }
  }
  var this_1 = destination.g2();
  return copyToArray(this_1);
};
protoOf(ItemRepository).e5s = function (itemNames) {
  if (!(itemNames == null)) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = itemNames.length;
    while (inductionVariable < last) {
      var element = itemNames[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.catalog.ItemRepository.clear.<anonymous>' call
      this.d5s_1.r2(element);
    }
  } else {
    this.d5s_1.m2();
  }
};
protoOf(ItemRepository).clear = function (itemNames, $super) {
  itemNames = itemNames === VOID ? null : itemNames;
  return this.e5s(itemNames);
};
protoOf(ItemRepository).set = function (name, item) {
  // Inline function 'kotlin.collections.set' call
  this.d5s_1.q2(name, item);
};
function ReadOnlyItemRepository() {
}
function Companion_1() {
  Companion_instance_2 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.f5s_1 = [null, null, null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().lb(), DoubleSerializer_getInstance()), null, null];
}
protoOf(Companion_1).z18 = function () {
  return $serializer_getInstance_5();
};
var Companion_instance_2;
function Companion_getInstance_9() {
  if (Companion_instance_2 == null)
    new Companion_1();
  return Companion_instance_2;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.AssemblyChildDTO', this, 7);
  tmp0_serialDesc.lw('partKey', false);
  tmp0_serialDesc.lw('connector', true);
  tmp0_serialDesc.lw('connectorOnHost', true);
  tmp0_serialDesc.lw('position', true);
  tmp0_serialDesc.lw('transform', true);
  tmp0_serialDesc.lw('children', true);
  tmp0_serialDesc.lw('locked', true);
  this.g5s_1 = tmp0_serialDesc;
}
protoOf($serializer).h5s = function (encoder, value) {
  var tmp0_desc = this.g5s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_9().f5s_1;
  tmp1_output.qq(tmp0_desc, 0, value.partKey);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.connector == null)) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.connector);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.connectorOnHost == null)) {
    tmp1_output.uq(tmp0_desc, 2, StringSerializer_getInstance(), value.connectorOnHost);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.position == null)) {
    tmp1_output.uq(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), value.position);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.transform == null)) {
    tmp1_output.uq(tmp0_desc, 4, tmp2_cached[4], value.transform);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.children == null)) {
    tmp1_output.uq(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), value.children);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.locked === true)) {
    tmp1_output.uq(tmp0_desc, 6, BooleanSerializer_getInstance(), value.locked);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer).ul = function (encoder, value) {
  return this.h5s(encoder, value instanceof AssemblyChildDTO ? value : THROW_CCE());
};
protoOf($serializer).vl = function (decoder) {
  var tmp0_desc = this.g5s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_input = decoder.bp(tmp0_desc);
  var tmp12_cached = Companion_getInstance_9().f5s_1;
  if (tmp11_input.rp()) {
    tmp4_local0 = tmp11_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp11_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp11_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp11_input.pp(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp11_input.pp(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp11_input.pp(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp11_input.pp(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp11_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp11_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp11_input.pp(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp11_input.pp(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp11_input.pp(tmp0_desc, 3, PositionTemplateSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp11_input.pp(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp11_input.pp(tmp0_desc, 5, new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5()), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp11_input.pp(tmp0_desc, 6, BooleanSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp11_input.cp(tmp0_desc);
  return AssemblyChildDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
};
protoOf($serializer).tl = function () {
  return this.g5s_1;
};
protoOf($serializer).ex = function () {
  var tmp0_cached = Companion_getInstance_9().f5s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(PositionTemplateSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable(new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5())), get_nullable(BooleanSerializer_getInstance())];
};
var $serializer_instance;
function $serializer_getInstance_5() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function AssemblyChildDTO_init_$Init$(seen0, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_5().g5s_1);
  }
  $this.partKey = partKey;
  if (0 === (seen0 & 2))
    $this.connector = null;
  else
    $this.connector = connector;
  if (0 === (seen0 & 4))
    $this.connectorOnHost = null;
  else
    $this.connectorOnHost = connectorOnHost;
  if (0 === (seen0 & 8))
    $this.position = null;
  else
    $this.position = position;
  if (0 === (seen0 & 16))
    $this.transform = null;
  else
    $this.transform = transform;
  if (0 === (seen0 & 32))
    $this.children = null;
  else
    $this.children = children;
  if (0 === (seen0 & 64))
    $this.locked = true;
  else
    $this.locked = locked;
  return $this;
}
function AssemblyChildDTO_init_$Create$(seen0, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker) {
  return AssemblyChildDTO_init_$Init$(seen0, partKey, connector, connectorOnHost, position, transform, children, locked, serializationConstructorMarker, objectCreate(protoOf(AssemblyChildDTO)));
}
function AssemblyChildDTO(partKey, connector, connectorOnHost, position, transform, children, locked) {
  Companion_getInstance_9();
  connector = connector === VOID ? null : connector;
  connectorOnHost = connectorOnHost === VOID ? null : connectorOnHost;
  position = position === VOID ? null : position;
  transform = transform === VOID ? null : transform;
  children = children === VOID ? null : children;
  locked = locked === VOID ? true : locked;
  this.partKey = partKey;
  this.connector = connector;
  this.connectorOnHost = connectorOnHost;
  this.position = position;
  this.transform = transform;
  this.children = children;
  this.locked = locked;
}
protoOf(AssemblyChildDTO).f1m = function () {
  return this.partKey;
};
protoOf(AssemblyChildDTO).t1m = function () {
  return this.connector;
};
protoOf(AssemblyChildDTO).s1m = function () {
  return this.connectorOnHost;
};
protoOf(AssemblyChildDTO).f2w = function () {
  return this.position;
};
protoOf(AssemblyChildDTO).z2a = function () {
  return this.transform;
};
protoOf(AssemblyChildDTO).i1m = function () {
  return this.children;
};
protoOf(AssemblyChildDTO).j1m = function () {
  return this.locked;
};
function Companion_2() {
}
protoOf(Companion_2).z18 = function () {
  return $serializer_getInstance_6();
};
var Companion_instance_3;
function Companion_getInstance_10() {
  return Companion_instance_3;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.ColliderDTO', this, 8);
  tmp0_serialDesc.lw('dimension', true);
  tmp0_serialDesc.lw('id', false);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('layer', true);
  tmp0_serialDesc.lw('margin', true);
  tmp0_serialDesc.lw('padding', true);
  tmp0_serialDesc.lw('compartment', true);
  tmp0_serialDesc.lw('sourceTemplateId', true);
  this.i5s_1 = tmp0_serialDesc;
}
protoOf($serializer_0).j5s = function (encoder, value) {
  var tmp0_desc = this.i5s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.dimension == null)) {
    tmp1_output.uq(tmp0_desc, 0, Companion_getInstance_4(), value.dimension);
  }
  tmp1_output.qq(tmp0_desc, 1, value.id);
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.type === 'box')) {
    tmp1_output.qq(tmp0_desc, 2, value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.layer === 'collision')) {
    tmp1_output.qq(tmp0_desc, 3, value.layer);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.margin == null)) {
    tmp1_output.uq(tmp0_desc, 4, MarginTemplateSerializer_getInstance(), value.margin);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.padding == null)) {
    tmp1_output.uq(tmp0_desc, 5, MarginTemplateSerializer_getInstance(), value.padding);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.compartment == null)) {
    tmp1_output.uq(tmp0_desc, 6, Companion_getInstance_5(), value.compartment);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.sourceTemplateId === '')) {
    tmp1_output.qq(tmp0_desc, 7, value.sourceTemplateId);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_0).ul = function (encoder, value) {
  return this.j5s(encoder, value instanceof ColliderDTO ? value : THROW_CCE());
};
protoOf($serializer_0).vl = function (decoder) {
  var tmp0_desc = this.i5s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_local5 = null;
  var tmp10_local6 = null;
  var tmp11_local7 = null;
  var tmp12_input = decoder.bp(tmp0_desc);
  if (tmp12_input.rp()) {
    tmp4_local0 = tmp12_input.pp(tmp0_desc, 0, Companion_getInstance_4(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp12_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp12_input.lp(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp12_input.lp(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp12_input.pp(tmp0_desc, 4, MarginTemplateSerializer_getInstance(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp12_input.pp(tmp0_desc, 5, MarginTemplateSerializer_getInstance(), tmp9_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp12_input.pp(tmp0_desc, 6, Companion_getInstance_5(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp12_input.lp(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp12_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp12_input.pp(tmp0_desc, 0, Companion_getInstance_4(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp12_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp12_input.lp(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp12_input.lp(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp12_input.pp(tmp0_desc, 4, MarginTemplateSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp12_input.pp(tmp0_desc, 5, MarginTemplateSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp12_input.pp(tmp0_desc, 6, Companion_getInstance_5(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp12_input.lp(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp12_input.cp(tmp0_desc);
  return ColliderDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
};
protoOf($serializer_0).tl = function () {
  return this.i5s_1;
};
protoOf($serializer_0).ex = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(Companion_getInstance_4()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(Companion_getInstance_5()), StringSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_6() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ColliderDTO_init_$Init$(seen0, dimension, id, type, layer, margin, padding, compartment, sourceTemplateId, serializationConstructorMarker, $this) {
  if (!(2 === (2 & seen0))) {
    throwMissingFieldException(seen0, 2, $serializer_getInstance_6().i5s_1);
  }
  if (0 === (seen0 & 1))
    $this.dimension = null;
  else
    $this.dimension = dimension;
  $this.id = id;
  if (0 === (seen0 & 4))
    $this.type = 'box';
  else
    $this.type = type;
  if (0 === (seen0 & 8))
    $this.layer = 'collision';
  else
    $this.layer = layer;
  if (0 === (seen0 & 16))
    $this.margin = null;
  else
    $this.margin = margin;
  if (0 === (seen0 & 32))
    $this.padding = null;
  else
    $this.padding = padding;
  if (0 === (seen0 & 64))
    $this.compartment = null;
  else
    $this.compartment = compartment;
  if (0 === (seen0 & 128))
    $this.sourceTemplateId = '';
  else
    $this.sourceTemplateId = sourceTemplateId;
  return $this;
}
function ColliderDTO_init_$Create$(seen0, dimension, id, type, layer, margin, padding, compartment, sourceTemplateId, serializationConstructorMarker) {
  return ColliderDTO_init_$Init$(seen0, dimension, id, type, layer, margin, padding, compartment, sourceTemplateId, serializationConstructorMarker, objectCreate(protoOf(ColliderDTO)));
}
function ColliderDTO(dimension, id, type, layer, margin, padding, compartment, sourceTemplateId) {
  dimension = dimension === VOID ? null : dimension;
  type = type === VOID ? 'box' : type;
  layer = layer === VOID ? 'collision' : layer;
  margin = margin === VOID ? null : margin;
  padding = padding === VOID ? null : padding;
  compartment = compartment === VOID ? null : compartment;
  sourceTemplateId = sourceTemplateId === VOID ? '' : sourceTemplateId;
  this.dimension = dimension;
  this.id = id;
  this.type = type;
  this.layer = layer;
  this.margin = margin;
  this.padding = padding;
  this.compartment = compartment;
  this.sourceTemplateId = sourceTemplateId;
}
protoOf(ColliderDTO).k5j = function () {
  return this.dimension;
};
protoOf(ColliderDTO).n1s = function () {
  return this.id;
};
protoOf(ColliderDTO).w2a = function () {
  return this.type;
};
protoOf(ColliderDTO).l49 = function () {
  return this.layer;
};
protoOf(ColliderDTO).k48 = function () {
  return this.margin;
};
protoOf(ColliderDTO).l5j = function () {
  return this.padding;
};
protoOf(ColliderDTO).m5j = function () {
  return this.compartment;
};
protoOf(ColliderDTO).n5j = function (_set____db54di) {
  this.sourceTemplateId = _set____db54di;
};
protoOf(ColliderDTO).o5j = function () {
  return this.sourceTemplateId;
};
protoOf(ColliderDTO).getPolyhedronsForSize = function (size) {
  var tmp;
  if (this.type === 'frame') {
    var tmp_0 = Companion_getInstance_3();
    var tmp0_safe_receiver = this.margin;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toMargin();
    var tmp_1 = tmp1_elvis_lhs == null ? new Margin() : tmp1_elvis_lhs;
    var tmp_2 = ensureNotNull(this.padding).toMargin();
    var tmp2_safe_receiver = this.compartment;
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.component.ColliderDTO.getPolyhedronsForSize.<anonymous>' call
      var tmp0_elvis_lhs = tmp2_safe_receiver.width;
      var tmp_4 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs_0 = tmp2_safe_receiver.height;
      tmp_3 = new Size(tmp_4, tmp1_elvis_lhs_0 == null ? 0.0 : tmp1_elvis_lhs_0);
    }
    var tmp_5 = tmp_0.h3c(size, tmp_1, tmp_2, tmp_3);
    tmp = isArray(tmp_5) ? tmp_5 : THROW_CCE();
  } else {
    var tmp_6;
    if (this.dimension == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.ikea.range.ipex.range.dto.component.ColliderDTO.getPolyhedronsForSize.<anonymous>' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_6 = [this.dimension.getPolyhedronForSize(size)];
    }
    var tmp4_elvis_lhs = tmp_6;
    var tmp_7;
    if (tmp4_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      var tmp5_width = size.b2y_1;
      var tmp6_height = size.c2y_1;
      var tmp7_depth = size.d2y_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_7 = [(new DynamicRangeDimension(VOID, VOID, tmp7_depth, VOID, tmp6_height, VOID, VOID, VOID, tmp5_width)).getPolyhedronForSize(size)];
    } else {
      tmp_7 = tmp4_elvis_lhs;
    }
    tmp = tmp_7;
  }
  return tmp;
};
function CustomSerializer() {
  CustomSerializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.component.ProductDTO', null, 3);
  tmp0_serialDesc.lw('dexfItemId', false);
  tmp0_serialDesc.lw('type', true);
  tmp0_serialDesc.lw('partsInPackage', true);
  this.k5s_1 = tmp0_serialDesc;
}
protoOf(CustomSerializer).vl = function (decoder) {
  var element = decoder.ap(Companion_instance.z18());
  var tmp;
  if (element instanceof JsonObject) {
    var tmp_0;
    try {
      var tmp_1 = element.d19('dexfItemId');
      var tmp_2 = (tmp_1 instanceof JsonPrimitive ? tmp_1 : THROW_CCE()).e19();
      var tmp_3 = element.d19('type');
      var tmp0_safe_receiver = (tmp_3 == null ? true : tmp_3 instanceof JsonPrimitive) ? tmp_3 : THROW_CCE();
      var tmp_4 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e19();
      var tmp_5 = element.d19('partsInPackage');
      var tmp1_safe_receiver = (tmp_5 == null ? true : tmp_5 instanceof JsonPrimitive) ? tmp_5 : THROW_CCE();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : toIntOrNull(tmp2_safe_receiver);
      tmp_0 = new ProductDTO(tmp_2, tmp_4, tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs);
    } catch ($p) {
      var tmp_6;
      if ($p instanceof Exception) {
        var e = $p;
        var message = 'Product component malformed in JSON: ' + element.toString() + '. ' + e.message;
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        throw $p;
      }
    }
    tmp = tmp_0;
  } else {
    if (element instanceof JsonPrimitive) {
      tmp = new ProductDTO(element.e19());
    } else {
      var message_0 = 'Product component malformed in JSON: ' + toString(element);
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
  }
  return tmp;
};
protoOf(CustomSerializer).tl = function () {
  return this.k5s_1;
};
protoOf(CustomSerializer).l5s = function (encoder, value) {
  var tmp0_desc = this.k5s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  tmp1_output.qq(tmp0_desc, 0, value.dexfItemId);
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.type == null)) {
    tmp1_output.uq(tmp0_desc, 1, StringSerializer_getInstance(), value.type);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.partsInPackage === 1)) {
    tmp1_output.lq(tmp0_desc, 2, value.partsInPackage);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf(CustomSerializer).ul = function (encoder, value) {
  return this.l5s(encoder, value instanceof ProductDTO ? value : THROW_CCE());
};
protoOf(CustomSerializer).z18 = function () {
  return CustomSerializer_getInstance_2();
};
var CustomSerializer_instance;
function CustomSerializer_getInstance_2() {
  if (CustomSerializer_instance == null)
    new CustomSerializer();
  return CustomSerializer_instance;
}
function ProductDTO(dexfItemId, type, partsInPackage) {
  CustomSerializer_getInstance_2();
  type = type === VOID ? null : type;
  partsInPackage = partsInPackage === VOID ? 1 : partsInPackage;
  this.dexfItemId = dexfItemId;
  this.type = type;
  this.partsInPackage = partsInPackage;
}
protoOf(ProductDTO).m5s = function () {
  return this.dexfItemId;
};
protoOf(ProductDTO).w2a = function () {
  return this.type;
};
protoOf(ProductDTO).q5e = function () {
  return this.partsInPackage;
};
function inheritCustomComponents($this, parentCCBs) {
  var result = toMutableMap($this.customComponents);
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = parentCCBs.i2().k();
  while (tmp0_iterator.m()) {
    var element = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritCustomComponents.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.b2();
    // Inline function 'kotlin.collections.component2' call
    var parentCCB = element.c2();
    var childCCB = result.f2(key);
    if (!(childCCB == null)) {
      // Inline function 'kotlin.collections.set' call
      var value = childCCB.inherit(parentCCB);
      result.q2(key, value);
    } else {
      // Inline function 'kotlin.collections.set' call
      result.q2(key, parentCCB);
    }
  }
  return result;
}
function inheritAssembly($this, assemblyDTO, otherAssemblyDTO) {
  var tmp;
  if (otherAssemblyDTO == null) {
    tmp = assemblyDTO;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = otherAssemblyDTO.length;
    while (inductionVariable < last) {
      var element = otherAssemblyDTO[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAssembly.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = assemblyDTO.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = assemblyDTO[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAssembly.<anonymous>.<anonymous>' call
          if (element_0.partKey === element.partKey) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_0(assemblyDTO, destination);
  }
  return tmp;
}
function inheritColliders($this, colliderDTO, otherColliderDTO) {
  var tmp;
  if (otherColliderDTO == null) {
    tmp = colliderDTO;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = otherColliderDTO.length;
    while (inductionVariable < last) {
      var element = otherColliderDTO[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritColliders.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = colliderDTO.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = colliderDTO[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritColliders.<anonymous>.<anonymous>' call
          if (element_0.id === element.id) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_0(colliderDTO, destination);
  }
  return tmp;
}
function inheritFunctionalZones($this, functionalZones, otherFunctionalZones) {
  var tmp;
  if (otherFunctionalZones == null) {
    tmp = functionalZones;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = otherFunctionalZones.length;
    while (inductionVariable < last) {
      var element = otherFunctionalZones[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritFunctionalZones.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = functionalZones.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = functionalZones[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritFunctionalZones.<anonymous>.<anonymous>' call
          if (element_0.id === element.id) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_0(functionalZones, destination);
  }
  return tmp;
}
function inheritConnectors($this, connectorDTO, otherConnectorDTO) {
  var tmp;
  if (otherConnectorDTO == null) {
    tmp = connectorDTO;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = otherConnectorDTO.length;
    while (inductionVariable < last) {
      var element = otherConnectorDTO[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritConnectors.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = connectorDTO.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = connectorDTO[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritConnectors.<anonymous>.<anonymous>' call
          if (element_0.name === element.name) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_0(connectorDTO, destination);
  }
  return tmp;
}
function inheritProductStructure($this, productStructureDTO, otherProductStructureDTO) {
  var tmp;
  if (otherProductStructureDTO == null) {
    tmp = productStructureDTO;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = otherProductStructureDTO.length;
    while (inductionVariable < last) {
      var element = otherProductStructureDTO[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritProductStructure.<anonymous>' call
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable_0 = 0;
        var last_0 = productStructureDTO.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = productStructureDTO[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritProductStructure.<anonymous>.<anonymous>' call
          if (element_0.partKey === element.partKey) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      if (tmp$ret$1) {
        destination.h(element);
      }
    }
    tmp = plus_0(productStructureDTO, destination);
  }
  return tmp;
}
function inheritMeta($this, meta, otherMeta) {
  var tmp;
  if (otherMeta == null) {
    tmp = meta;
  } else {
    return plus_1(otherMeta, meta);
  }
  return tmp;
}
function inheritAllowedDoorPairs($this, allowedDoorPairs, otherAllowedDoorPairs) {
  var tmp;
  if (otherAllowedDoorPairs == null) {
    tmp = allowedDoorPairs;
  } else {
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var pairs = otherAllowedDoorPairs.concat(allowedDoorPairs);
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var element = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAllowedDoorPairs.<anonymous>' call
      sort(element);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = pairs.length;
    while (inductionVariable_0 < last_0) {
      var e = pairs[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inheritAllowedDoorPairs.<anonymous>' call
      var key = joinToString_0(e, '-');
      if (set.h(key)) {
        list.h(e);
      }
    }
    tmp = copyToArray(list);
  }
  return tmp;
}
function Companion_3() {
  Companion_instance_4 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  var tmp_0 = new ReferenceArraySerializer(getKClass(AssemblyChildDTO), $serializer_getInstance_5());
  var tmp_1 = new ReferenceArraySerializer(getKClass(ColliderDTO), $serializer_getInstance_6());
  var tmp_2 = new ReferenceArraySerializer(getKClass(ConnectorItemTemplate), Companion_getInstance_6());
  var tmp_3 = new ReferenceArraySerializer(getKClass(ProductStructureItemTemplate), $serializer_getInstance_1());
  var tmp_4 = new ReferenceArraySerializer(getKClass(ColliderDTO), $serializer_getInstance_6());
  var tmp_5 = new ReferenceArraySerializer(PrimitiveClasses_getInstance().mb(), new ReferenceArraySerializer(PrimitiveClasses_getInstance().jb(), IntSerializer_getInstance()));
  var tmp_6 = new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonElementSerializer_getInstance());
  var tmp_7 = StringSerializer_getInstance();
  var tmp_8 = getKClass(CustomComponentBuilder);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.n5s_1 = [tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, null, null, null, null, null, null, null, tmp_5, null, null, null, null, null, null, null, null, null, null, tmp_6, null, null, null, null, null, null, null, null, null, new LinkedHashMapSerializer(tmp_7, PolymorphicSerializer_init_$Create$(tmp_8, tmp$ret$2))];
}
protoOf(Companion_3).z18 = function () {
  return $serializer_getInstance_7();
};
var Companion_instance_4;
function Companion_getInstance_11() {
  if (Companion_instance_4 == null)
    new Companion_3();
  return Companion_instance_4;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.ItemComponentsDTO', this, 34);
  tmp0_serialDesc.lw('assembly', true);
  tmp0_serialDesc.lw('colliders', true);
  tmp0_serialDesc.lw('connectors', true);
  tmp0_serialDesc.lw('productStructure', true);
  tmp0_serialDesc.lw('functionalZones', true);
  tmp0_serialDesc.lw('autoAdaptGroup', true);
  tmp0_serialDesc.lw('product', true);
  tmp0_serialDesc.lw('modelURI', true);
  tmp0_serialDesc.lw('modelTransform', true);
  tmp0_serialDesc.lw('selectable', true);
  tmp0_serialDesc.lw('outlineable', true);
  tmp0_serialDesc.lw('draggable', true);
  tmp0_serialDesc.lw('allowedDoorPairs', true);
  tmp0_serialDesc.lw('autoAdaptHost', true);
  tmp0_serialDesc.lw('door', true);
  tmp0_serialDesc.lw('doorFront', true);
  tmp0_serialDesc.lw('handle', true);
  tmp0_serialDesc.lw('drawer', true);
  tmp0_serialDesc.lw('frame', true);
  tmp0_serialDesc.lw('leg', true);
  tmp0_serialDesc.lw('innerLight', true);
  tmp0_serialDesc.lw('outerLight', true);
  tmp0_serialDesc.lw('outlined', true);
  tmp0_serialDesc.lw('meta', true);
  tmp0_serialDesc.lw('propping', true);
  tmp0_serialDesc.lw('alwaysHangDown', true);
  tmp0_serialDesc.lw('serializeEntity', true);
  tmp0_serialDesc.lw('placementZoneByHeight', true);
  tmp0_serialDesc.lw('functionalMargin', true);
  tmp0_serialDesc.lw('recommendedInitialPositionFromFloor', true);
  tmp0_serialDesc.lw('visualLightSource', true);
  tmp0_serialDesc.lw('dragSurfaces', true);
  tmp0_serialDesc.lw('dragProjectionPoint', true);
  tmp0_serialDesc.lw('customComponents', true);
  this.o5s_1 = tmp0_serialDesc;
}
protoOf($serializer_1).p5s = function (encoder, value) {
  var tmp0_desc = this.o5s_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_11().n5s_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.assembly == null)) {
    tmp1_output.uq(tmp0_desc, 0, tmp2_cached[0], value.assembly);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.colliders == null)) {
    tmp1_output.uq(tmp0_desc, 1, tmp2_cached[1], value.colliders);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.connectors == null)) {
    tmp1_output.uq(tmp0_desc, 2, tmp2_cached[2], value.connectors);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.productStructure == null)) {
    tmp1_output.uq(tmp0_desc, 3, tmp2_cached[3], value.productStructure);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.functionalZones == null)) {
    tmp1_output.uq(tmp0_desc, 4, tmp2_cached[4], value.functionalZones);
  }
  if (tmp1_output.yq(tmp0_desc, 5) ? true : !(value.autoAdaptGroup == null)) {
    tmp1_output.uq(tmp0_desc, 5, CustomSerializer_getInstance(), value.autoAdaptGroup);
  }
  if (tmp1_output.yq(tmp0_desc, 6) ? true : !(value.product == null)) {
    tmp1_output.uq(tmp0_desc, 6, CustomSerializer_getInstance_2(), value.product);
  }
  if (tmp1_output.yq(tmp0_desc, 7) ? true : !(value.modelURI == null)) {
    tmp1_output.uq(tmp0_desc, 7, StringSerializer_getInstance(), value.modelURI);
  }
  if (tmp1_output.yq(tmp0_desc, 8) ? true : !(value.modelTransform == null)) {
    tmp1_output.uq(tmp0_desc, 8, $serializer_getInstance(), value.modelTransform);
  }
  if (tmp1_output.yq(tmp0_desc, 9) ? true : !(value.selectable == null)) {
    tmp1_output.uq(tmp0_desc, 9, BooleanSerializer_getInstance(), value.selectable);
  }
  if (tmp1_output.yq(tmp0_desc, 10) ? true : !(value.outlineable == null)) {
    tmp1_output.uq(tmp0_desc, 10, BooleanSerializer_getInstance(), value.outlineable);
  }
  if (tmp1_output.yq(tmp0_desc, 11) ? true : !(value.draggable == null)) {
    tmp1_output.uq(tmp0_desc, 11, BooleanSerializer_getInstance(), value.draggable);
  }
  if (tmp1_output.yq(tmp0_desc, 12) ? true : !(value.allowedDoorPairs == null)) {
    tmp1_output.uq(tmp0_desc, 12, tmp2_cached[12], value.allowedDoorPairs);
  }
  if (tmp1_output.yq(tmp0_desc, 13) ? true : !(value.autoAdaptHost == null)) {
    tmp1_output.uq(tmp0_desc, 13, CustomSerializer_getInstance_0(), value.autoAdaptHost);
  }
  if (tmp1_output.yq(tmp0_desc, 14) ? true : !(value.door == null)) {
    tmp1_output.uq(tmp0_desc, 14, BooleanSerializer_getInstance(), value.door);
  }
  if (tmp1_output.yq(tmp0_desc, 15) ? true : !(value.doorFront == null)) {
    tmp1_output.uq(tmp0_desc, 15, BooleanSerializer_getInstance(), value.doorFront);
  }
  if (tmp1_output.yq(tmp0_desc, 16) ? true : !(value.handle == null)) {
    tmp1_output.uq(tmp0_desc, 16, BooleanSerializer_getInstance(), value.handle);
  }
  if (tmp1_output.yq(tmp0_desc, 17) ? true : !(value.drawer == null)) {
    tmp1_output.uq(tmp0_desc, 17, BooleanSerializer_getInstance(), value.drawer);
  }
  if (tmp1_output.yq(tmp0_desc, 18) ? true : !(value.frame == null)) {
    tmp1_output.uq(tmp0_desc, 18, BooleanSerializer_getInstance(), value.frame);
  }
  if (tmp1_output.yq(tmp0_desc, 19) ? true : !(value.leg == null)) {
    tmp1_output.uq(tmp0_desc, 19, BooleanSerializer_getInstance(), value.leg);
  }
  if (tmp1_output.yq(tmp0_desc, 20) ? true : !(value.innerLight == null)) {
    tmp1_output.uq(tmp0_desc, 20, BooleanSerializer_getInstance(), value.innerLight);
  }
  if (tmp1_output.yq(tmp0_desc, 21) ? true : !(value.outerLight == null)) {
    tmp1_output.uq(tmp0_desc, 21, BooleanSerializer_getInstance(), value.outerLight);
  }
  if (tmp1_output.yq(tmp0_desc, 22) ? true : !(value.outlined == null)) {
    tmp1_output.uq(tmp0_desc, 22, BooleanSerializer_getInstance(), value.outlined);
  }
  if (tmp1_output.yq(tmp0_desc, 23) ? true : !(value.meta == null)) {
    tmp1_output.uq(tmp0_desc, 23, tmp2_cached[23], value.meta);
  }
  if (tmp1_output.yq(tmp0_desc, 24) ? true : !(value.propping == null)) {
    tmp1_output.uq(tmp0_desc, 24, BooleanSerializer_getInstance(), value.propping);
  }
  if (tmp1_output.yq(tmp0_desc, 25) ? true : !(value.alwaysHangDown == null)) {
    tmp1_output.uq(tmp0_desc, 25, BooleanSerializer_getInstance(), value.alwaysHangDown);
  }
  if (tmp1_output.yq(tmp0_desc, 26) ? true : !(value.serializeEntity == null)) {
    tmp1_output.uq(tmp0_desc, 26, BooleanSerializer_getInstance(), value.serializeEntity);
  }
  if (tmp1_output.yq(tmp0_desc, 27) ? true : !(value.placementZoneByHeight == null)) {
    tmp1_output.uq(tmp0_desc, 27, $serializer_getInstance_2(), value.placementZoneByHeight);
  }
  if (tmp1_output.yq(tmp0_desc, 28) ? true : !(value.functionalMargin == null)) {
    tmp1_output.uq(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), value.functionalMargin);
  }
  if (tmp1_output.yq(tmp0_desc, 29) ? true : !(value.recommendedInitialPositionFromFloor == null)) {
    tmp1_output.uq(tmp0_desc, 29, IntSerializer_getInstance(), value.recommendedInitialPositionFromFloor);
  }
  if (tmp1_output.yq(tmp0_desc, 30) ? true : !(value.visualLightSource == null)) {
    tmp1_output.uq(tmp0_desc, 30, $serializer_getInstance_3(), value.visualLightSource);
  }
  if (tmp1_output.yq(tmp0_desc, 31) ? true : !(value.dragSurfaces == null)) {
    tmp1_output.uq(tmp0_desc, 31, CustomSerializer_getInstance_1(), value.dragSurfaces);
  }
  if (tmp1_output.yq(tmp0_desc, 32) ? true : !(value.dragProjectionPoint == null)) {
    tmp1_output.uq(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), value.dragProjectionPoint);
  }
  var tmp;
  if (tmp1_output.yq(tmp0_desc, 33)) {
    tmp = true;
  } else {
    var tmp_0 = value.customComponents;
    // Inline function 'kotlin.collections.mapOf' call
    var tmp$ret$0 = emptyMap();
    tmp = !equals(tmp_0, tmp$ret$0);
  }
  if (tmp) {
    tmp1_output.sq(tmp0_desc, 33, tmp2_cached[33], value.customComponents);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_1).ul = function (encoder, value) {
  return this.p5s(encoder, value instanceof ItemComponentsDTO ? value : THROW_CCE());
};
protoOf($serializer_1).vl = function (decoder) {
  var tmp0_desc = this.o5s_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_bitMask1 = 0;
  var tmp5_local0 = null;
  var tmp6_local1 = null;
  var tmp7_local2 = null;
  var tmp8_local3 = null;
  var tmp9_local4 = null;
  var tmp10_local5 = null;
  var tmp11_local6 = null;
  var tmp12_local7 = null;
  var tmp13_local8 = null;
  var tmp14_local9 = null;
  var tmp15_local10 = null;
  var tmp16_local11 = null;
  var tmp17_local12 = null;
  var tmp18_local13 = null;
  var tmp19_local14 = null;
  var tmp20_local15 = null;
  var tmp21_local16 = null;
  var tmp22_local17 = null;
  var tmp23_local18 = null;
  var tmp24_local19 = null;
  var tmp25_local20 = null;
  var tmp26_local21 = null;
  var tmp27_local22 = null;
  var tmp28_local23 = null;
  var tmp29_local24 = null;
  var tmp30_local25 = null;
  var tmp31_local26 = null;
  var tmp32_local27 = null;
  var tmp33_local28 = null;
  var tmp34_local29 = null;
  var tmp35_local30 = null;
  var tmp36_local31 = null;
  var tmp37_local32 = null;
  var tmp38_local33 = null;
  var tmp39_input = decoder.bp(tmp0_desc);
  var tmp40_cached = Companion_getInstance_11().n5s_1;
  if (tmp39_input.rp()) {
    tmp5_local0 = tmp39_input.pp(tmp0_desc, 0, tmp40_cached[0], tmp5_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp6_local1 = tmp39_input.pp(tmp0_desc, 1, tmp40_cached[1], tmp6_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp7_local2 = tmp39_input.pp(tmp0_desc, 2, tmp40_cached[2], tmp7_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp8_local3 = tmp39_input.pp(tmp0_desc, 3, tmp40_cached[3], tmp8_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp9_local4 = tmp39_input.pp(tmp0_desc, 4, tmp40_cached[4], tmp9_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp10_local5 = tmp39_input.pp(tmp0_desc, 5, CustomSerializer_getInstance(), tmp10_local5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp11_local6 = tmp39_input.pp(tmp0_desc, 6, CustomSerializer_getInstance_2(), tmp11_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp12_local7 = tmp39_input.pp(tmp0_desc, 7, StringSerializer_getInstance(), tmp12_local7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp13_local8 = tmp39_input.pp(tmp0_desc, 8, $serializer_getInstance(), tmp13_local8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
    tmp14_local9 = tmp39_input.pp(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp14_local9);
    tmp3_bitMask0 = tmp3_bitMask0 | 512;
    tmp15_local10 = tmp39_input.pp(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp15_local10);
    tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    tmp16_local11 = tmp39_input.pp(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp16_local11);
    tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    tmp17_local12 = tmp39_input.pp(tmp0_desc, 12, tmp40_cached[12], tmp17_local12);
    tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    tmp18_local13 = tmp39_input.pp(tmp0_desc, 13, CustomSerializer_getInstance_0(), tmp18_local13);
    tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    tmp19_local14 = tmp39_input.pp(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp19_local14);
    tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    tmp20_local15 = tmp39_input.pp(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp20_local15);
    tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    tmp21_local16 = tmp39_input.pp(tmp0_desc, 16, BooleanSerializer_getInstance(), tmp21_local16);
    tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    tmp22_local17 = tmp39_input.pp(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp22_local17);
    tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    tmp23_local18 = tmp39_input.pp(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp23_local18);
    tmp3_bitMask0 = tmp3_bitMask0 | 262144;
    tmp24_local19 = tmp39_input.pp(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp24_local19);
    tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    tmp25_local20 = tmp39_input.pp(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp25_local20);
    tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    tmp26_local21 = tmp39_input.pp(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp26_local21);
    tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
    tmp27_local22 = tmp39_input.pp(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp27_local22);
    tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    tmp28_local23 = tmp39_input.pp(tmp0_desc, 23, tmp40_cached[23], tmp28_local23);
    tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
    tmp29_local24 = tmp39_input.pp(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp29_local24);
    tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
    tmp30_local25 = tmp39_input.pp(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp30_local25);
    tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
    tmp31_local26 = tmp39_input.pp(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp31_local26);
    tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
    tmp32_local27 = tmp39_input.pp(tmp0_desc, 27, $serializer_getInstance_2(), tmp32_local27);
    tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
    tmp33_local28 = tmp39_input.pp(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), tmp33_local28);
    tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
    tmp34_local29 = tmp39_input.pp(tmp0_desc, 29, IntSerializer_getInstance(), tmp34_local29);
    tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
    tmp35_local30 = tmp39_input.pp(tmp0_desc, 30, $serializer_getInstance_3(), tmp35_local30);
    tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
    tmp36_local31 = tmp39_input.pp(tmp0_desc, 31, CustomSerializer_getInstance_1(), tmp36_local31);
    tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
    tmp37_local32 = tmp39_input.pp(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), tmp37_local32);
    tmp4_bitMask1 = tmp4_bitMask1 | 1;
    tmp38_local33 = tmp39_input.np(tmp0_desc, 33, tmp40_cached[33], tmp38_local33);
    tmp4_bitMask1 = tmp4_bitMask1 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp39_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp5_local0 = tmp39_input.pp(tmp0_desc, 0, tmp40_cached[0], tmp5_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp6_local1 = tmp39_input.pp(tmp0_desc, 1, tmp40_cached[1], tmp6_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp7_local2 = tmp39_input.pp(tmp0_desc, 2, tmp40_cached[2], tmp7_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp8_local3 = tmp39_input.pp(tmp0_desc, 3, tmp40_cached[3], tmp8_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp9_local4 = tmp39_input.pp(tmp0_desc, 4, tmp40_cached[4], tmp9_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp10_local5 = tmp39_input.pp(tmp0_desc, 5, CustomSerializer_getInstance(), tmp10_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp11_local6 = tmp39_input.pp(tmp0_desc, 6, CustomSerializer_getInstance_2(), tmp11_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp12_local7 = tmp39_input.pp(tmp0_desc, 7, StringSerializer_getInstance(), tmp12_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp13_local8 = tmp39_input.pp(tmp0_desc, 8, $serializer_getInstance(), tmp13_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        case 9:
          tmp14_local9 = tmp39_input.pp(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp14_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          break;
        case 10:
          tmp15_local10 = tmp39_input.pp(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp15_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          break;
        case 11:
          tmp16_local11 = tmp39_input.pp(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp16_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          break;
        case 12:
          tmp17_local12 = tmp39_input.pp(tmp0_desc, 12, tmp40_cached[12], tmp17_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          break;
        case 13:
          tmp18_local13 = tmp39_input.pp(tmp0_desc, 13, CustomSerializer_getInstance_0(), tmp18_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          break;
        case 14:
          tmp19_local14 = tmp39_input.pp(tmp0_desc, 14, BooleanSerializer_getInstance(), tmp19_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          break;
        case 15:
          tmp20_local15 = tmp39_input.pp(tmp0_desc, 15, BooleanSerializer_getInstance(), tmp20_local15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
          break;
        case 16:
          tmp21_local16 = tmp39_input.pp(tmp0_desc, 16, BooleanSerializer_getInstance(), tmp21_local16);
          tmp3_bitMask0 = tmp3_bitMask0 | 65536;
          break;
        case 17:
          tmp22_local17 = tmp39_input.pp(tmp0_desc, 17, BooleanSerializer_getInstance(), tmp22_local17);
          tmp3_bitMask0 = tmp3_bitMask0 | 131072;
          break;
        case 18:
          tmp23_local18 = tmp39_input.pp(tmp0_desc, 18, BooleanSerializer_getInstance(), tmp23_local18);
          tmp3_bitMask0 = tmp3_bitMask0 | 262144;
          break;
        case 19:
          tmp24_local19 = tmp39_input.pp(tmp0_desc, 19, BooleanSerializer_getInstance(), tmp24_local19);
          tmp3_bitMask0 = tmp3_bitMask0 | 524288;
          break;
        case 20:
          tmp25_local20 = tmp39_input.pp(tmp0_desc, 20, BooleanSerializer_getInstance(), tmp25_local20);
          tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
          break;
        case 21:
          tmp26_local21 = tmp39_input.pp(tmp0_desc, 21, BooleanSerializer_getInstance(), tmp26_local21);
          tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
          break;
        case 22:
          tmp27_local22 = tmp39_input.pp(tmp0_desc, 22, BooleanSerializer_getInstance(), tmp27_local22);
          tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
          break;
        case 23:
          tmp28_local23 = tmp39_input.pp(tmp0_desc, 23, tmp40_cached[23], tmp28_local23);
          tmp3_bitMask0 = tmp3_bitMask0 | 8388608;
          break;
        case 24:
          tmp29_local24 = tmp39_input.pp(tmp0_desc, 24, BooleanSerializer_getInstance(), tmp29_local24);
          tmp3_bitMask0 = tmp3_bitMask0 | 16777216;
          break;
        case 25:
          tmp30_local25 = tmp39_input.pp(tmp0_desc, 25, BooleanSerializer_getInstance(), tmp30_local25);
          tmp3_bitMask0 = tmp3_bitMask0 | 33554432;
          break;
        case 26:
          tmp31_local26 = tmp39_input.pp(tmp0_desc, 26, BooleanSerializer_getInstance(), tmp31_local26);
          tmp3_bitMask0 = tmp3_bitMask0 | 67108864;
          break;
        case 27:
          tmp32_local27 = tmp39_input.pp(tmp0_desc, 27, $serializer_getInstance_2(), tmp32_local27);
          tmp3_bitMask0 = tmp3_bitMask0 | 134217728;
          break;
        case 28:
          tmp33_local28 = tmp39_input.pp(tmp0_desc, 28, MarginTemplateSerializer_getInstance(), tmp33_local28);
          tmp3_bitMask0 = tmp3_bitMask0 | 268435456;
          break;
        case 29:
          tmp34_local29 = tmp39_input.pp(tmp0_desc, 29, IntSerializer_getInstance(), tmp34_local29);
          tmp3_bitMask0 = tmp3_bitMask0 | 536870912;
          break;
        case 30:
          tmp35_local30 = tmp39_input.pp(tmp0_desc, 30, $serializer_getInstance_3(), tmp35_local30);
          tmp3_bitMask0 = tmp3_bitMask0 | 1073741824;
          break;
        case 31:
          tmp36_local31 = tmp39_input.pp(tmp0_desc, 31, CustomSerializer_getInstance_1(), tmp36_local31);
          tmp3_bitMask0 = tmp3_bitMask0 | -2147483648;
          break;
        case 32:
          tmp37_local32 = tmp39_input.pp(tmp0_desc, 32, PositionTemplateSerializer_getInstance(), tmp37_local32);
          tmp4_bitMask1 = tmp4_bitMask1 | 1;
          break;
        case 33:
          tmp38_local33 = tmp39_input.np(tmp0_desc, 33, tmp40_cached[33], tmp38_local33);
          tmp4_bitMask1 = tmp4_bitMask1 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp39_input.cp(tmp0_desc);
  return ItemComponentsDTO_init_$Create$(tmp3_bitMask0, tmp4_bitMask1, tmp5_local0, tmp6_local1, tmp7_local2, tmp8_local3, tmp9_local4, tmp10_local5, tmp11_local6, tmp12_local7, tmp13_local8, tmp14_local9, tmp15_local10, tmp16_local11, tmp17_local12, tmp18_local13, tmp19_local14, tmp20_local15, tmp21_local16, tmp22_local17, tmp23_local18, tmp24_local19, tmp25_local20, tmp26_local21, tmp27_local22, tmp28_local23, tmp29_local24, tmp30_local25, tmp31_local26, tmp32_local27, tmp33_local28, tmp34_local29, tmp35_local30, tmp36_local31, tmp37_local32, tmp38_local33, null);
};
protoOf($serializer_1).tl = function () {
  return this.o5s_1;
};
protoOf($serializer_1).ex = function () {
  var tmp0_cached = Companion_getInstance_11().n5s_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), get_nullable(CustomSerializer_getInstance()), get_nullable(CustomSerializer_getInstance_2()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[12]), get_nullable(CustomSerializer_getInstance_0()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(tmp0_cached[23]), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable(MarginTemplateSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable($serializer_getInstance_3()), get_nullable(CustomSerializer_getInstance_1()), get_nullable(PositionTemplateSerializer_getInstance()), tmp0_cached[33]];
};
var $serializer_instance_1;
function $serializer_getInstance_7() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ItemComponentsDTO_init_$Init$(seen0, seen1, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker, $this) {
  if (!!(!(0 === (0 & seen0)) | !(0 === (0 & seen1)))) {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([seen0, seen1]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 0]);
    throwArrayMissingFieldException(tmp, tmp$ret$1, $serializer_getInstance_7().o5s_1);
  }
  if (0 === (seen0 & 1))
    $this.assembly = null;
  else
    $this.assembly = assembly;
  if (0 === (seen0 & 2))
    $this.colliders = null;
  else
    $this.colliders = colliders;
  if (0 === (seen0 & 4))
    $this.connectors = null;
  else
    $this.connectors = connectors;
  if (0 === (seen0 & 8))
    $this.productStructure = null;
  else
    $this.productStructure = productStructure;
  if (0 === (seen0 & 16))
    $this.functionalZones = null;
  else
    $this.functionalZones = functionalZones;
  if (0 === (seen0 & 32))
    $this.autoAdaptGroup = null;
  else
    $this.autoAdaptGroup = autoAdaptGroup;
  if (0 === (seen0 & 64))
    $this.product = null;
  else
    $this.product = product;
  if (0 === (seen0 & 128))
    $this.modelURI = null;
  else
    $this.modelURI = modelURI;
  if (0 === (seen0 & 256))
    $this.modelTransform = null;
  else
    $this.modelTransform = modelTransform;
  if (0 === (seen0 & 512))
    $this.selectable = null;
  else
    $this.selectable = selectable;
  if (0 === (seen0 & 1024))
    $this.outlineable = null;
  else
    $this.outlineable = outlineable;
  if (0 === (seen0 & 2048))
    $this.draggable = null;
  else
    $this.draggable = draggable;
  if (0 === (seen0 & 4096))
    $this.allowedDoorPairs = null;
  else
    $this.allowedDoorPairs = allowedDoorPairs;
  if (0 === (seen0 & 8192))
    $this.autoAdaptHost = null;
  else
    $this.autoAdaptHost = autoAdaptHost;
  if (0 === (seen0 & 16384))
    $this.door = null;
  else
    $this.door = door;
  if (0 === (seen0 & 32768))
    $this.doorFront = null;
  else
    $this.doorFront = doorFront;
  if (0 === (seen0 & 65536))
    $this.handle = null;
  else
    $this.handle = handle;
  if (0 === (seen0 & 131072))
    $this.drawer = null;
  else
    $this.drawer = drawer;
  if (0 === (seen0 & 262144))
    $this.frame = null;
  else
    $this.frame = frame;
  if (0 === (seen0 & 524288))
    $this.leg = null;
  else
    $this.leg = leg;
  if (0 === (seen0 & 1048576))
    $this.innerLight = null;
  else
    $this.innerLight = innerLight;
  if (0 === (seen0 & 2097152))
    $this.outerLight = null;
  else
    $this.outerLight = outerLight;
  if (0 === (seen0 & 4194304))
    $this.outlined = null;
  else
    $this.outlined = outlined;
  if (0 === (seen0 & 8388608))
    $this.meta = null;
  else
    $this.meta = meta;
  if (0 === (seen0 & 16777216))
    $this.propping = null;
  else
    $this.propping = propping;
  if (0 === (seen0 & 33554432))
    $this.alwaysHangDown = null;
  else
    $this.alwaysHangDown = alwaysHangDown;
  if (0 === (seen0 & 67108864))
    $this.serializeEntity = null;
  else
    $this.serializeEntity = serializeEntity;
  if (0 === (seen0 & 134217728))
    $this.placementZoneByHeight = null;
  else
    $this.placementZoneByHeight = placementZoneByHeight;
  if (0 === (seen0 & 268435456))
    $this.functionalMargin = null;
  else
    $this.functionalMargin = functionalMargin;
  if (0 === (seen0 & 536870912))
    $this.recommendedInitialPositionFromFloor = null;
  else
    $this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
  if (0 === (seen0 & 1073741824))
    $this.visualLightSource = null;
  else
    $this.visualLightSource = visualLightSource;
  if (0 === (seen0 & -2147483648))
    $this.dragSurfaces = null;
  else
    $this.dragSurfaces = dragSurfaces;
  if (0 === (seen1 & 1))
    $this.dragProjectionPoint = null;
  else
    $this.dragProjectionPoint = dragProjectionPoint;
  if (0 === (seen1 & 2)) {
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.mapOf' call
    tmp_0.customComponents = emptyMap();
  } else
    $this.customComponents = customComponents;
  return $this;
}
function ItemComponentsDTO_init_$Create$(seen0, seen1, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker) {
  return ItemComponentsDTO_init_$Init$(seen0, seen1, assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents, serializationConstructorMarker, objectCreate(protoOf(ItemComponentsDTO)));
}
function ItemComponentsDTO(assembly, colliders, connectors, productStructure, functionalZones, autoAdaptGroup, product, modelURI, modelTransform, selectable, outlineable, draggable, allowedDoorPairs, autoAdaptHost, door, doorFront, handle, drawer, frame, leg, innerLight, outerLight, outlined, meta, propping, alwaysHangDown, serializeEntity, placementZoneByHeight, functionalMargin, recommendedInitialPositionFromFloor, visualLightSource, dragSurfaces, dragProjectionPoint, customComponents) {
  Companion_getInstance_11();
  assembly = assembly === VOID ? null : assembly;
  colliders = colliders === VOID ? null : colliders;
  connectors = connectors === VOID ? null : connectors;
  productStructure = productStructure === VOID ? null : productStructure;
  functionalZones = functionalZones === VOID ? null : functionalZones;
  autoAdaptGroup = autoAdaptGroup === VOID ? null : autoAdaptGroup;
  product = product === VOID ? null : product;
  modelURI = modelURI === VOID ? null : modelURI;
  modelTransform = modelTransform === VOID ? null : modelTransform;
  selectable = selectable === VOID ? null : selectable;
  outlineable = outlineable === VOID ? null : outlineable;
  draggable = draggable === VOID ? null : draggable;
  allowedDoorPairs = allowedDoorPairs === VOID ? null : allowedDoorPairs;
  autoAdaptHost = autoAdaptHost === VOID ? null : autoAdaptHost;
  door = door === VOID ? null : door;
  doorFront = doorFront === VOID ? null : doorFront;
  handle = handle === VOID ? null : handle;
  drawer = drawer === VOID ? null : drawer;
  frame = frame === VOID ? null : frame;
  leg = leg === VOID ? null : leg;
  innerLight = innerLight === VOID ? null : innerLight;
  outerLight = outerLight === VOID ? null : outerLight;
  outlined = outlined === VOID ? null : outlined;
  meta = meta === VOID ? null : meta;
  propping = propping === VOID ? null : propping;
  alwaysHangDown = alwaysHangDown === VOID ? null : alwaysHangDown;
  serializeEntity = serializeEntity === VOID ? null : serializeEntity;
  placementZoneByHeight = placementZoneByHeight === VOID ? null : placementZoneByHeight;
  functionalMargin = functionalMargin === VOID ? null : functionalMargin;
  recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor === VOID ? null : recommendedInitialPositionFromFloor;
  visualLightSource = visualLightSource === VOID ? null : visualLightSource;
  dragSurfaces = dragSurfaces === VOID ? null : dragSurfaces;
  dragProjectionPoint = dragProjectionPoint === VOID ? null : dragProjectionPoint;
  var tmp;
  if (customComponents === VOID) {
    // Inline function 'kotlin.collections.mapOf' call
    tmp = emptyMap();
  } else {
    tmp = customComponents;
  }
  customComponents = tmp;
  this.assembly = assembly;
  this.colliders = colliders;
  this.connectors = connectors;
  this.productStructure = productStructure;
  this.functionalZones = functionalZones;
  this.autoAdaptGroup = autoAdaptGroup;
  this.product = product;
  this.modelURI = modelURI;
  this.modelTransform = modelTransform;
  this.selectable = selectable;
  this.outlineable = outlineable;
  this.draggable = draggable;
  this.allowedDoorPairs = allowedDoorPairs;
  this.autoAdaptHost = autoAdaptHost;
  this.door = door;
  this.doorFront = doorFront;
  this.handle = handle;
  this.drawer = drawer;
  this.frame = frame;
  this.leg = leg;
  this.innerLight = innerLight;
  this.outerLight = outerLight;
  this.outlined = outlined;
  this.meta = meta;
  this.propping = propping;
  this.alwaysHangDown = alwaysHangDown;
  this.serializeEntity = serializeEntity;
  this.placementZoneByHeight = placementZoneByHeight;
  this.functionalMargin = functionalMargin;
  this.recommendedInitialPositionFromFloor = recommendedInitialPositionFromFloor;
  this.visualLightSource = visualLightSource;
  this.dragSurfaces = dragSurfaces;
  this.dragProjectionPoint = dragProjectionPoint;
  this.customComponents = customComponents;
}
protoOf(ItemComponentsDTO).q5s = function (_set____db54di) {
  this.assembly = _set____db54di;
};
protoOf(ItemComponentsDTO).c5k = function () {
  return this.assembly;
};
protoOf(ItemComponentsDTO).r5s = function (_set____db54di) {
  this.colliders = _set____db54di;
};
protoOf(ItemComponentsDTO).s5s = function () {
  return this.colliders;
};
protoOf(ItemComponentsDTO).a5k = function (_set____db54di) {
  this.connectors = _set____db54di;
};
protoOf(ItemComponentsDTO).t2c = function () {
  return this.connectors;
};
protoOf(ItemComponentsDTO).z5l = function (_set____db54di) {
  this.productStructure = _set____db54di;
};
protoOf(ItemComponentsDTO).a5m = function () {
  return this.productStructure;
};
protoOf(ItemComponentsDTO).t5s = function (_set____db54di) {
  this.functionalZones = _set____db54di;
};
protoOf(ItemComponentsDTO).z5j = function () {
  return this.functionalZones;
};
protoOf(ItemComponentsDTO).r5e = function () {
  return this.autoAdaptGroup;
};
protoOf(ItemComponentsDTO).d5i = function () {
  return this.product;
};
protoOf(ItemComponentsDTO).m5e = function () {
  return this.modelURI;
};
protoOf(ItemComponentsDTO).s5g = function () {
  return this.modelTransform;
};
protoOf(ItemComponentsDTO).e5k = function () {
  return this.selectable;
};
protoOf(ItemComponentsDTO).f5k = function (_set____db54di) {
  this.outlineable = _set____db54di;
};
protoOf(ItemComponentsDTO).g5k = function () {
  return this.outlineable;
};
protoOf(ItemComponentsDTO).h5k = function (_set____db54di) {
  this.draggable = _set____db54di;
};
protoOf(ItemComponentsDTO).i5k = function () {
  return this.draggable;
};
protoOf(ItemComponentsDTO).j5k = function (_set____db54di) {
  this.allowedDoorPairs = _set____db54di;
};
protoOf(ItemComponentsDTO).k5k = function () {
  return this.allowedDoorPairs;
};
protoOf(ItemComponentsDTO).l5k = function (_set____db54di) {
  this.autoAdaptHost = _set____db54di;
};
protoOf(ItemComponentsDTO).m5k = function () {
  return this.autoAdaptHost;
};
protoOf(ItemComponentsDTO).p5k = function (_set____db54di) {
  this.door = _set____db54di;
};
protoOf(ItemComponentsDTO).q5k = function () {
  return this.door;
};
protoOf(ItemComponentsDTO).r5k = function (_set____db54di) {
  this.doorFront = _set____db54di;
};
protoOf(ItemComponentsDTO).s5k = function () {
  return this.doorFront;
};
protoOf(ItemComponentsDTO).t5k = function (_set____db54di) {
  this.handle = _set____db54di;
};
protoOf(ItemComponentsDTO).u5k = function () {
  return this.handle;
};
protoOf(ItemComponentsDTO).v5k = function (_set____db54di) {
  this.drawer = _set____db54di;
};
protoOf(ItemComponentsDTO).w5k = function () {
  return this.drawer;
};
protoOf(ItemComponentsDTO).x5k = function (_set____db54di) {
  this.frame = _set____db54di;
};
protoOf(ItemComponentsDTO).y5k = function () {
  return this.frame;
};
protoOf(ItemComponentsDTO).z5k = function (_set____db54di) {
  this.leg = _set____db54di;
};
protoOf(ItemComponentsDTO).a5l = function () {
  return this.leg;
};
protoOf(ItemComponentsDTO).u5s = function (_set____db54di) {
  this.innerLight = _set____db54di;
};
protoOf(ItemComponentsDTO).v5s = function () {
  return this.innerLight;
};
protoOf(ItemComponentsDTO).w5s = function (_set____db54di) {
  this.outerLight = _set____db54di;
};
protoOf(ItemComponentsDTO).x5s = function () {
  return this.outerLight;
};
protoOf(ItemComponentsDTO).d5l = function (_set____db54di) {
  this.outlined = _set____db54di;
};
protoOf(ItemComponentsDTO).e5l = function () {
  return this.outlined;
};
protoOf(ItemComponentsDTO).t5e = function (_set____db54di) {
  this.meta = _set____db54di;
};
protoOf(ItemComponentsDTO).u5e = function () {
  return this.meta;
};
protoOf(ItemComponentsDTO).f5l = function (_set____db54di) {
  this.propping = _set____db54di;
};
protoOf(ItemComponentsDTO).r4a = function () {
  return this.propping;
};
protoOf(ItemComponentsDTO).g5l = function (_set____db54di) {
  this.alwaysHangDown = _set____db54di;
};
protoOf(ItemComponentsDTO).h5l = function () {
  return this.alwaysHangDown;
};
protoOf(ItemComponentsDTO).i5l = function (_set____db54di) {
  this.serializeEntity = _set____db54di;
};
protoOf(ItemComponentsDTO).j5l = function () {
  return this.serializeEntity;
};
protoOf(ItemComponentsDTO).k5l = function (_set____db54di) {
  this.placementZoneByHeight = _set____db54di;
};
protoOf(ItemComponentsDTO).l5l = function () {
  return this.placementZoneByHeight;
};
protoOf(ItemComponentsDTO).m5l = function (_set____db54di) {
  this.functionalMargin = _set____db54di;
};
protoOf(ItemComponentsDTO).n5l = function () {
  return this.functionalMargin;
};
protoOf(ItemComponentsDTO).o5l = function (_set____db54di) {
  this.recommendedInitialPositionFromFloor = _set____db54di;
};
protoOf(ItemComponentsDTO).p5l = function () {
  return this.recommendedInitialPositionFromFloor;
};
protoOf(ItemComponentsDTO).q5l = function (_set____db54di) {
  this.visualLightSource = _set____db54di;
};
protoOf(ItemComponentsDTO).r5l = function () {
  return this.visualLightSource;
};
protoOf(ItemComponentsDTO).v5l = function (_set____db54di) {
  this.dragSurfaces = _set____db54di;
};
protoOf(ItemComponentsDTO).w5l = function () {
  return this.dragSurfaces;
};
protoOf(ItemComponentsDTO).x5l = function (_set____db54di) {
  this.dragProjectionPoint = _set____db54di;
};
protoOf(ItemComponentsDTO).y5l = function () {
  return this.dragProjectionPoint;
};
protoOf(ItemComponentsDTO).y5s = function (_set____db54di) {
  this.customComponents = _set____db54di;
};
protoOf(ItemComponentsDTO).z5s = function () {
  return this.customComponents;
};
protoOf(ItemComponentsDTO).inherit = function (parentComponents) {
  var tmp0_safe_receiver = this.assembly;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp = inheritAssembly(this, tmp0_safe_receiver, parentComponents.assembly);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp40_assembly = tmp1_elvis_lhs == null ? parentComponents.assembly : tmp1_elvis_lhs;
  var tmp2_safe_receiver = this.colliders;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_0 = inheritColliders(this, tmp2_safe_receiver, parentComponents.colliders);
  }
  var tmp3_elvis_lhs = tmp_0;
  var tmp41_colliders = tmp3_elvis_lhs == null ? parentComponents.colliders : tmp3_elvis_lhs;
  var tmp4_safe_receiver = this.connectors;
  var tmp_1;
  if (tmp4_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_1 = inheritConnectors(this, tmp4_safe_receiver, parentComponents.connectors);
  }
  var tmp5_elvis_lhs = tmp_1;
  var tmp42_connectors = tmp5_elvis_lhs == null ? parentComponents.connectors : tmp5_elvis_lhs;
  var tmp6_safe_receiver = this.productStructure;
  var tmp_2;
  if (tmp6_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_2 = inheritProductStructure(this, tmp6_safe_receiver, parentComponents.productStructure);
  }
  var tmp7_elvis_lhs = tmp_2;
  var tmp43_productStructure = tmp7_elvis_lhs == null ? parentComponents.productStructure : tmp7_elvis_lhs;
  var tmp8_safe_receiver = this.meta;
  var tmp_3;
  if (tmp8_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_3 = inheritMeta(this, tmp8_safe_receiver, parentComponents.meta);
  }
  var tmp9_elvis_lhs = tmp_3;
  var tmp44_meta = tmp9_elvis_lhs == null ? parentComponents.meta : tmp9_elvis_lhs;
  var tmp10_safe_receiver = this.allowedDoorPairs;
  var tmp_4;
  if (tmp10_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_4 = inheritAllowedDoorPairs(this, tmp10_safe_receiver, parentComponents.allowedDoorPairs);
  }
  var tmp11_elvis_lhs = tmp_4;
  var tmp45_allowedDoorPairs = tmp11_elvis_lhs == null ? parentComponents.allowedDoorPairs : tmp11_elvis_lhs;
  var tmp12_safe_receiver = this.functionalZones;
  var tmp_5;
  if (tmp12_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemComponentsDTO.inherit.<anonymous>' call
    tmp_5 = inheritFunctionalZones(this, tmp12_safe_receiver, parentComponents.functionalZones);
  }
  var tmp13_elvis_lhs = tmp_5;
  var tmp46_functionalZones = tmp13_elvis_lhs == null ? parentComponents.functionalZones : tmp13_elvis_lhs;
  var tmp14_elvis_lhs = this.autoAdaptGroup;
  var tmp47_autoAdaptGroup = tmp14_elvis_lhs == null ? parentComponents.autoAdaptGroup : tmp14_elvis_lhs;
  var tmp15_elvis_lhs = this.product;
  var tmp48_product = tmp15_elvis_lhs == null ? parentComponents.product : tmp15_elvis_lhs;
  var tmp16_elvis_lhs = this.modelURI;
  var tmp49_modelURI = tmp16_elvis_lhs == null ? parentComponents.modelURI : tmp16_elvis_lhs;
  var tmp17_elvis_lhs = this.modelTransform;
  var tmp50_modelTransform = tmp17_elvis_lhs == null ? parentComponents.modelTransform : tmp17_elvis_lhs;
  var tmp18_elvis_lhs = this.selectable;
  var tmp51_selectable = tmp18_elvis_lhs == null ? parentComponents.selectable : tmp18_elvis_lhs;
  var tmp19_elvis_lhs = this.outlineable;
  var tmp52_outlineable = tmp19_elvis_lhs == null ? parentComponents.outlineable : tmp19_elvis_lhs;
  var tmp20_elvis_lhs = this.draggable;
  var tmp53_draggable = tmp20_elvis_lhs == null ? parentComponents.draggable : tmp20_elvis_lhs;
  var tmp21_elvis_lhs = this.autoAdaptHost;
  var tmp54_autoAdaptHost = tmp21_elvis_lhs == null ? parentComponents.autoAdaptHost : tmp21_elvis_lhs;
  var tmp22_elvis_lhs = this.door;
  var tmp55_door = tmp22_elvis_lhs == null ? parentComponents.door : tmp22_elvis_lhs;
  var tmp23_elvis_lhs = this.doorFront;
  var tmp56_doorFront = tmp23_elvis_lhs == null ? parentComponents.doorFront : tmp23_elvis_lhs;
  var tmp24_elvis_lhs = this.handle;
  var tmp57_handle = tmp24_elvis_lhs == null ? parentComponents.handle : tmp24_elvis_lhs;
  var tmp25_elvis_lhs = this.drawer;
  var tmp58_drawer = tmp25_elvis_lhs == null ? parentComponents.drawer : tmp25_elvis_lhs;
  var tmp26_elvis_lhs = this.frame;
  var tmp59_frame = tmp26_elvis_lhs == null ? parentComponents.frame : tmp26_elvis_lhs;
  var tmp27_elvis_lhs = this.leg;
  var tmp60_leg = tmp27_elvis_lhs == null ? parentComponents.leg : tmp27_elvis_lhs;
  var tmp28_elvis_lhs = this.innerLight;
  var tmp61_innerLight = tmp28_elvis_lhs == null ? parentComponents.innerLight : tmp28_elvis_lhs;
  var tmp29_elvis_lhs = this.outerLight;
  var tmp62_outerLight = tmp29_elvis_lhs == null ? parentComponents.outerLight : tmp29_elvis_lhs;
  var tmp30_elvis_lhs = this.outlined;
  var tmp63_outlined = tmp30_elvis_lhs == null ? parentComponents.outlined : tmp30_elvis_lhs;
  var tmp31_elvis_lhs = this.propping;
  var tmp64_propping = tmp31_elvis_lhs == null ? parentComponents.propping : tmp31_elvis_lhs;
  var tmp32_elvis_lhs = this.alwaysHangDown;
  var tmp65_alwaysHangDown = tmp32_elvis_lhs == null ? parentComponents.alwaysHangDown : tmp32_elvis_lhs;
  var tmp33_elvis_lhs = this.serializeEntity;
  var tmp66_serializeEntity = tmp33_elvis_lhs == null ? parentComponents.serializeEntity : tmp33_elvis_lhs;
  var tmp34_elvis_lhs = this.placementZoneByHeight;
  var tmp67_placementZoneByHeight = tmp34_elvis_lhs == null ? parentComponents.placementZoneByHeight : tmp34_elvis_lhs;
  var tmp35_elvis_lhs = this.functionalMargin;
  var tmp68_functionalMargin = tmp35_elvis_lhs == null ? parentComponents.functionalMargin : tmp35_elvis_lhs;
  var tmp36_elvis_lhs = this.recommendedInitialPositionFromFloor;
  var tmp69_recommendedInitialPositionFromFloor = tmp36_elvis_lhs == null ? parentComponents.recommendedInitialPositionFromFloor : tmp36_elvis_lhs;
  var tmp37_elvis_lhs = this.visualLightSource;
  var tmp70_visualLightSource = tmp37_elvis_lhs == null ? parentComponents.visualLightSource : tmp37_elvis_lhs;
  var tmp38_elvis_lhs = this.dragSurfaces;
  var tmp71_dragSurfaces = tmp38_elvis_lhs == null ? parentComponents.dragSurfaces : tmp38_elvis_lhs;
  var tmp39_elvis_lhs = this.dragProjectionPoint;
  var tmp72_dragProjectionPoint = tmp39_elvis_lhs == null ? parentComponents.dragProjectionPoint : tmp39_elvis_lhs;
  var tmp73_customComponents = inheritCustomComponents(this, parentComponents.customComponents);
  var item = new ItemComponentsDTO(tmp40_assembly, tmp41_colliders, tmp42_connectors, tmp43_productStructure, tmp46_functionalZones, tmp47_autoAdaptGroup, tmp48_product, tmp49_modelURI, tmp50_modelTransform, tmp51_selectable, tmp52_outlineable, tmp53_draggable, tmp45_allowedDoorPairs, tmp54_autoAdaptHost, tmp55_door, tmp56_doorFront, tmp57_handle, tmp58_drawer, tmp59_frame, tmp60_leg, tmp61_innerLight, tmp62_outerLight, tmp63_outlined, tmp44_meta, tmp64_propping, tmp65_alwaysHangDown, tmp66_serializeEntity, tmp67_placementZoneByHeight, tmp68_functionalMargin, tmp69_recommendedInitialPositionFromFloor, tmp70_visualLightSource, tmp71_dragSurfaces, tmp72_dragProjectionPoint, tmp73_customComponents);
  return item;
};
function Companion_4() {
  Companion_instance_5 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.a5t_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new ReferenceArraySerializer(getKClass(Part), $serializer_getInstance_4())];
}
protoOf(Companion_4).z18 = function () {
  return $serializer_getInstance_8();
};
var Companion_instance_5;
function Companion_getInstance_12() {
  if (Companion_instance_5 == null)
    new Companion_4();
  return Companion_instance_5;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.ItemParametersDTO', this, 3);
  tmp0_serialDesc.lw('size', true);
  tmp0_serialDesc.lw('labels', true);
  tmp0_serialDesc.lw('parts', true);
  this.b5t_1 = tmp0_serialDesc;
}
protoOf($serializer_2).c5t = function (encoder, value) {
  var tmp0_desc = this.b5t_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_12().a5t_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.size == null)) {
    tmp1_output.uq(tmp0_desc, 0, $serializer_getInstance_0(), value.size);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.labels == null)) {
    tmp1_output.uq(tmp0_desc, 1, tmp2_cached[1], value.labels);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.parts == null)) {
    tmp1_output.uq(tmp0_desc, 2, tmp2_cached[2], value.parts);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_2).ul = function (encoder, value) {
  return this.c5t(encoder, value instanceof ItemParametersDTO ? value : THROW_CCE());
};
protoOf($serializer_2).vl = function (decoder) {
  var tmp0_desc = this.b5t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.bp(tmp0_desc);
  var tmp8_cached = Companion_getInstance_12().a5t_1;
  if (tmp7_input.rp()) {
    tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.pp(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.pp(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.pp(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.cp(tmp0_desc);
  return ItemParametersDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer_2).tl = function () {
  return this.b5t_1;
};
protoOf($serializer_2).ex = function () {
  var tmp0_cached = Companion_getInstance_12().a5t_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_0()), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2])];
};
var $serializer_instance_2;
function $serializer_getInstance_8() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function ItemParametersDTO_init_$Init$(seen0, size, labels, parts, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_8().b5t_1);
  }
  if (0 === (seen0 & 1))
    $this.size = null;
  else
    $this.size = size;
  if (0 === (seen0 & 2))
    $this.labels = null;
  else
    $this.labels = labels;
  if (0 === (seen0 & 4))
    $this.parts = null;
  else
    $this.parts = parts;
  return $this;
}
function ItemParametersDTO_init_$Create$(seen0, size, labels, parts, serializationConstructorMarker) {
  return ItemParametersDTO_init_$Init$(seen0, size, labels, parts, serializationConstructorMarker, objectCreate(protoOf(ItemParametersDTO)));
}
function ItemParametersDTO(size, labels, parts) {
  Companion_getInstance_12();
  size = size === VOID ? null : size;
  labels = labels === VOID ? null : labels;
  parts = parts === VOID ? null : parts;
  this.size = size;
  this.labels = labels;
  this.parts = parts;
}
protoOf(ItemParametersDTO).o = function () {
  return this.size;
};
protoOf(ItemParametersDTO).d5t = function () {
  return this.labels;
};
protoOf(ItemParametersDTO).o1s = function () {
  return this.parts;
};
protoOf(ItemParametersDTO).inherit = function (parentParameters) {
  var tmp0_safe_receiver = parentParameters.parts;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(tmp0_safe_receiver.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = tmp0_safe_receiver.length;
    while (inductionVariable < last) {
      var element = tmp0_safe_receiver[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
      var pair = new Pair(element.partKey, element);
      destination.q2(pair.rf_1, pair.sf_1);
    }
    tmp = destination;
  }
  var tmp1_elvis_lhs = tmp;
  var parentParts = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp2_safe_receiver = this.parts;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.associate' call
    var capacity_0 = coerceAtLeast(mapCapacity(tmp2_safe_receiver.length), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(capacity_0);
    var inductionVariable_0 = 0;
    var last_0 = tmp2_safe_receiver.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = tmp2_safe_receiver[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
      var pair_0 = new Pair(element_0.partKey, element_0);
      destination_0.q2(pair_0.rf_1, pair_0.sf_1);
    }
    tmp_0 = destination_0;
  }
  var tmp3_elvis_lhs = tmp_0;
  var parts = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  // Inline function 'kotlin.collections.map' call
  var this_0 = plus_1(parentParts, parts);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$_0(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.i2().k();
  while (tmp0_iterator.m()) {
    var item = tmp0_iterator.n();
    // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.inherit.<anonymous>' call
    var tmp$ret$7 = item.c2();
    destination_1.h(tmp$ret$7);
  }
  var newParts = copyToArray(destination_1);
  var tmp4_elvis_lhs = this.size;
  var tmp_1 = tmp4_elvis_lhs == null ? parentParameters.size : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = parentParameters.labels;
  var tmp_2 = tmp5_elvis_lhs == null ? emptyMap() : tmp5_elvis_lhs;
  var tmp6_elvis_lhs = this.labels;
  return new ItemParametersDTO(tmp_1, plus_1(tmp_2, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs), newParts);
};
protoOf(ItemParametersDTO).getLabels = function () {
  var tmp0_safe_receiver = this.labels;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(tmp0_safe_receiver.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = tmp0_safe_receiver.i2().k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.dto.item.ItemParametersDTO.getLabels.<anonymous>' call
      var tmp$ret$1 = new ParameterLabel(item.b2(), item.c2());
      destination.h(tmp$ret$1);
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    // Inline function 'kotlin.emptyArray' call
    tmp_1 = [];
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  return tmp_1;
};
function ParameterLabel(key, value) {
  this.key = key;
  this.value = value;
}
protoOf(ParameterLabel).b2 = function () {
  return this.key;
};
protoOf(ParameterLabel).c2 = function () {
  return this.value;
};
protoOf(ParameterLabel).tf = function () {
  return this.key;
};
protoOf(ParameterLabel).uf = function () {
  return this.value;
};
protoOf(ParameterLabel).c1t = function (key, value) {
  return new ParameterLabel(key, value);
};
protoOf(ParameterLabel).copy = function (key, value, $super) {
  key = key === VOID ? this.key : key;
  value = value === VOID ? this.value : value;
  return this.c1t(key, value);
};
protoOf(ParameterLabel).toString = function () {
  return 'ParameterLabel(key=' + this.key + ', value=' + this.value + ')';
};
protoOf(ParameterLabel).hashCode = function () {
  var result = getStringHashCode(this.key);
  result = imul(result, 31) + getStringHashCode(this.value) | 0;
  return result;
};
protoOf(ParameterLabel).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ParameterLabel))
    return false;
  var tmp0_other_with_cast = other instanceof ParameterLabel ? other : THROW_CCE();
  if (!(this.key === tmp0_other_with_cast.key))
    return false;
  if (!(this.value === tmp0_other_with_cast.value))
    return false;
  return true;
};
function Companion_5() {
  Companion_instance_6 = this;
  var tmp = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u5r_1 = [null, null, new ReferenceArraySerializer(PrimitiveClasses_getInstance().nb(), StringSerializer_getInstance()), null, null];
}
protoOf(Companion_5).z18 = function () {
  return $serializer_getInstance_9();
};
var Companion_instance_6;
function Companion_getInstance_13() {
  if (Companion_instance_6 == null)
    new Companion_5();
  return Companion_instance_6;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ikea.range.ipex.range.dto.item.RangeItemDTO', this, 5);
  tmp0_serialDesc.lw('id', true);
  tmp0_serialDesc.lw('description', true);
  tmp0_serialDesc.lw('inherits', true);
  tmp0_serialDesc.lw('parameters', true);
  tmp0_serialDesc.lw('components', true);
  this.e5t_1 = tmp0_serialDesc;
}
protoOf($serializer_3).f5t = function (encoder, value) {
  var tmp0_desc = this.e5t_1;
  var tmp1_output = encoder.bp(tmp0_desc);
  var tmp2_cached = Companion_getInstance_13().u5r_1;
  if (tmp1_output.yq(tmp0_desc, 0) ? true : !(value.id === '')) {
    tmp1_output.qq(tmp0_desc, 0, value.id);
  }
  if (tmp1_output.yq(tmp0_desc, 1) ? true : !(value.description === '')) {
    tmp1_output.qq(tmp0_desc, 1, value.description);
  }
  if (tmp1_output.yq(tmp0_desc, 2) ? true : !(value.inherits == null)) {
    tmp1_output.uq(tmp0_desc, 2, tmp2_cached[2], value.inherits);
  }
  if (tmp1_output.yq(tmp0_desc, 3) ? true : !(value.parameters == null)) {
    tmp1_output.uq(tmp0_desc, 3, $serializer_getInstance_8(), value.parameters);
  }
  if (tmp1_output.yq(tmp0_desc, 4) ? true : !(value.components == null)) {
    tmp1_output.uq(tmp0_desc, 4, $serializer_getInstance_7(), value.components);
  }
  tmp1_output.cp(tmp0_desc);
};
protoOf($serializer_3).ul = function (encoder, value) {
  return this.f5t(encoder, value instanceof RangeItemDTO ? value : THROW_CCE());
};
protoOf($serializer_3).vl = function (decoder) {
  var tmp0_desc = this.e5t_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = null;
  var tmp9_input = decoder.bp(tmp0_desc);
  var tmp10_cached = Companion_getInstance_13().u5r_1;
  if (tmp9_input.rp()) {
    tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp9_input.pp(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, $serializer_getInstance_8(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, $serializer_getInstance_7(), tmp8_local4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp9_input.sp(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp9_input.lp(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp9_input.lp(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp9_input.pp(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp9_input.pp(tmp0_desc, 3, $serializer_getInstance_8(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp9_input.pp(tmp0_desc, 4, $serializer_getInstance_7(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp9_input.cp(tmp0_desc);
  return RangeItemDTO_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
};
protoOf($serializer_3).tl = function () {
  return this.e5t_1;
};
protoOf($serializer_3).ex = function () {
  var tmp0_cached = Companion_getInstance_13().u5r_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2]), get_nullable($serializer_getInstance_8()), get_nullable($serializer_getInstance_7())];
};
var $serializer_instance_3;
function $serializer_getInstance_9() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function RangeItemDTO_init_$Init$(seen0, id, description, inherits, parameters, components, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_9().e5t_1);
  }
  if (0 === (seen0 & 1))
    $this.id = '';
  else
    $this.id = id;
  if (0 === (seen0 & 2))
    $this.description = '';
  else
    $this.description = description;
  if (0 === (seen0 & 4))
    $this.inherits = null;
  else
    $this.inherits = inherits;
  if (0 === (seen0 & 8))
    $this.parameters = null;
  else
    $this.parameters = parameters;
  if (0 === (seen0 & 16))
    $this.components = null;
  else
    $this.components = components;
  return $this;
}
function RangeItemDTO_init_$Create$(seen0, id, description, inherits, parameters, components, serializationConstructorMarker) {
  return RangeItemDTO_init_$Init$(seen0, id, description, inherits, parameters, components, serializationConstructorMarker, objectCreate(protoOf(RangeItemDTO)));
}
function RangeItemDTO(id, description, inherits, parameters, components) {
  Companion_getInstance_13();
  id = id === VOID ? '' : id;
  description = description === VOID ? '' : description;
  inherits = inherits === VOID ? null : inherits;
  parameters = parameters === VOID ? null : parameters;
  components = components === VOID ? null : components;
  this.id = id;
  this.description = description;
  this.inherits = inherits;
  this.parameters = parameters;
  this.components = components;
}
protoOf(RangeItemDTO).n1s = function () {
  return this.id;
};
protoOf(RangeItemDTO).h5h = function () {
  return this.description;
};
protoOf(RangeItemDTO).d5g = function () {
  return this.inherits;
};
protoOf(RangeItemDTO).g5t = function () {
  return this.parameters;
};
protoOf(RangeItemDTO).l1u = function () {
  return this.components;
};
protoOf(RangeItemDTO).inherit = function (parentItem) {
  var tmp0_safe_receiver = parentItem.components;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.RangeItemDTO.inherit.<anonymous>' call
    var tmp0_safe_receiver_0 = this.components;
    var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.inherit(tmp0_safe_receiver);
    tmp = tmp1_elvis_lhs == null ? (new ItemComponentsDTO()).inherit(tmp0_safe_receiver) : tmp1_elvis_lhs;
  }
  var tmp1_elvis_lhs_0 = tmp;
  var newComponents = tmp1_elvis_lhs_0 == null ? this.components : tmp1_elvis_lhs_0;
  var tmp2_safe_receiver = parentItem.parameters;
  var tmp_0;
  if (tmp2_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ikea.range.ipex.range.dto.item.RangeItemDTO.inherit.<anonymous>' call
    var tmp0_safe_receiver_1 = this.parameters;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.inherit(tmp2_safe_receiver);
    tmp_0 = tmp1_elvis_lhs_1 == null ? (new ItemParametersDTO()).inherit(tmp2_safe_receiver) : tmp1_elvis_lhs_1;
  }
  var tmp3_elvis_lhs = tmp_0;
  var newParameters = tmp3_elvis_lhs == null ? this.parameters : tmp3_elvis_lhs;
  return new RangeItemDTO(this.id, this.description, this.inherits, newParameters, newComponents);
};
function ItemParser$Companion$jsonParser$lambda($this$Json) {
  $this$Json.s17_1 = true;
  $this$Json.r17_1 = true;
  return Unit_instance;
}
function parseCustomComponents($this, item, itemJsonElement, parsers) {
  if (!(parsers == null)) {
    var knownComponentKeys = get_elementNames(Companion_getInstance_11().z18().tl());
    // Inline function 'kotlin.collections.find' call
    var this_0 = get_jsonObject(itemJsonElement).i2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.k();
      while (tmp0_iterator.m()) {
        var element = tmp0_iterator.n();
        // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>' call
        if (element.b2() === 'components') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var componentEntries = tmp$ret$1;
    if (componentEntries == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.associate' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = get_jsonObject(componentEntries.c2()).i2();
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator_0 = this_1.k();
      while (tmp0_iterator_0.m()) {
        var element_0 = tmp0_iterator_0.n();
        // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
        if (!contains_0(knownComponentKeys, element_0.b2())) {
          destination.h(element_0);
        }
      }
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_0 = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator_1 = destination.k();
      while (tmp0_iterator_1.m()) {
        var element_1 = tmp0_iterator_1.n();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
        var pair = to(element_1.b2(), element_1.c2());
        destination_0.q2(pair.rf_1, pair.sf_1);
      }
      var rawCustomComponents = destination_0;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_1 = ArrayList_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = rawCustomComponents.i2().k();
      while (tmp0_iterator_2.m()) {
        var element_2 = tmp0_iterator_2.n();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$14;
        $l$block_1: {
          // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.component1' call
          var key = element_2.b2();
          // Inline function 'kotlin.collections.component2' call
          var value = element_2.c2();
          var tmp$ret$13;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var tmp0_iterator_3 = parsers.k();
            while (tmp0_iterator_3.m()) {
              var element_3 = tmp0_iterator_3.n();
              // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseCustomComponents.<anonymous>.<anonymous>.<anonymous>' call
              var result = element_3.parse(key, toString(value));
              if (!(result == null)) {
                tmp$ret$13 = result;
                break $l$block_0;
              }
            }
            tmp$ret$13 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$13;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$14 = null;
            break $l$block_1;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var builder = tmp;
          tmp$ret$14 = to(key, builder);
        }
        var tmp0_safe_receiver = tmp$ret$14;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_1.h(tmp0_safe_receiver);
        }
      }
      var customComponents = toMap(destination_1);
      var tmp0_safe_receiver_0 = item.components;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.customComponents = customComponents;
      }
    }
  }
}
function Companion_6() {
  Companion_instance_7 = this;
  var tmp = this;
  tmp.h5t_1 = Json(VOID, ItemParser$Companion$jsonParser$lambda);
}
var Companion_instance_7;
function Companion_getInstance_14() {
  if (Companion_instance_7 == null)
    new Companion_6();
  return Companion_instance_7;
}
function ItemParser() {
  Companion_getInstance_14();
}
protoOf(ItemParser).r5r = function (itemJson, parsers) {
  var item = Companion_getInstance_14().h5t_1.w16(Companion_getInstance_13().z18(), itemJson);
  parseCustomComponents(this, item, Companion_getInstance_14().h5t_1.z16(itemJson), parsers);
  return item;
};
protoOf(ItemParser).t5r = function (itemsJson, parsers) {
  try {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_jsonArray(Companion_getInstance_14().h5t_1.z16(itemsJson));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.k();
    while (tmp0_iterator.m()) {
      var item = tmp0_iterator.n();
      // Inline function 'com.ikea.range.ipex.range.parser.ItemParser.parseItems.<anonymous>' call
      var item_0 = Companion_getInstance_14().h5t_1.w16(Companion_getInstance_13().z18(), toString(item));
      parseCustomComponents(this, item_0, item, parsers);
      destination.h(item_0);
    }
    return copyToArray(destination);
  } catch ($p) {
    if ($p instanceof Error_0) {
      var e = $p;
      // Inline function 'kotlin.error' call
      var message = toString_1(e.message);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      throw $p;
    }
  }
};
//region block: post-declaration
protoOf(IPEXRangeFormatCatalog).productSpecification = productSpecification;
protoOf(IPEXRangeFormatCatalog).createCustomAssembly = createCustomAssembly;
protoOf(IPEXRangeFormatCatalog).createCustomAssemblySpecification = createCustomAssemblySpecification;
defineProp(protoOf(IPEXRangeFormatCatalog), 'thisClassIsGuaranteedToNotModifyOrQueryCoreState', function () {
  return this.s1t();
});
protoOf($serializer).fx = typeParametersSerializers;
protoOf($serializer_0).fx = typeParametersSerializers;
protoOf($serializer_1).fx = typeParametersSerializers;
protoOf($serializer_2).fx = typeParametersSerializers;
protoOf($serializer_3).fx = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
defineProp(AmendableCatalog, 'Companion', Companion_getInstance_7);
defineProp(IPEXRangeFormatCatalog, 'Companion', Companion_getInstance_8);
defineProp(AssemblyChildDTO, 'Companion', Companion_getInstance_9);
defineProp(ColliderDTO, 'Companion', Companion_getInstance_10);
defineProp(ProductDTO, 'CustomSerializer', CustomSerializer_getInstance_2);
defineProp(ItemComponentsDTO, 'Companion', Companion_getInstance_11);
defineProp(ItemParametersDTO, 'Companion', Companion_getInstance_12);
defineProp(RangeItemDTO, 'Companion', Companion_getInstance_13);
export {
  ComponentsCommonData as ComponentsCommonData,
  StaticComponentBuilder as StaticComponentBuilder,
  PolyhedronColliderIdsPair as PolyhedronColliderIdsPair,
  AmendableCatalog as AmendableCatalog,
  IPEXRangeFormatCatalog as IPEXRangeFormatCatalog,
  ItemRepository as ItemRepository,
  AssemblyChildDTO as AssemblyChildDTO,
  ColliderDTO as ColliderDTO,
  ProductDTO as ProductDTO,
  ItemComponentsDTO as ItemComponentsDTO,
  ItemParametersDTO as ItemParametersDTO,
  ParameterLabel as ParameterLabel,
  RangeItemDTO as RangeItemDTO,
};
//endregion

//# sourceMappingURL=ipex-range-format.mjs.map
